{
  "colorTokens": {
    "auforumassurance": {
      "color-background": "var(--AuForumAssurance_Cream-50)",
      "color-bg-base-primary": "var(--AuForumAssurance_Rouge-brule)",
      "color-bg-base-primary-hover": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-base-primary-active": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-base-secondary": "var(--AuForumAssurance_Cream-50)",
      "color-bg-base-secondary-active": "var(--AuForumAssurance_Cream-100)",
      "color-bg-base-secondary-hover": "var(--AuForumAssurance_Cream-100)",
      "color-bg-base-tertiary": "var(--AuForumAssurance_Ink-900)",
      "color-bg-base-tertiary-hover": "var(--AuForumAssurance_Ink-900)",
      "color-bg-base-tertiary-active": "var(--AuForumAssurance_Ink-900)",
      "color-bg-base-normal": "var(--White)",
      "color-bg-base-active": "var(--AuForumAssurance_Orange-chaud)",
      "color-bg-base-disable": "var(--Gray200)",
      "color-bg-base-hover": "var(--AuForumAssurance_Cream-100)",
      "color-bg-base-focus": "var(--AuForumAssurance_Cream-100)",
      "color-bg-base-active-disable": "var(--Gray300)",
      "color-bg-base-inverse": "var(--AuForumAssurance_Ink-900)",
      "color-bg-base-highlight": "var(--AuForumAssurance_Orange-chaud)",
      "color-bg-base-normal-subtle": "var(--AuForumAssurance_Cream-100)",
      "color-bg-danger-primary": "var(--Red-500)",
      "color-bg-danger-primary-hover": "var(--Red-600)",
      "color-bg-danger-primary-active": "var(--Red-600)",
      "color-bg-danger-primary-disable": "var(--Gray100)",
      "color-bg-danger-inverse": "var(--Red-200)",
      "color-bg-danger-secondary": "var(--Red-100)",
      "color-bg-danger-secondary-hover": "var(--Red-100)",
      "color-bg-danger-secondary-active": "var(--Red-100)",
      "color-bg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-danger-tertiary": "var(--Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Red-200)",
      "color-bg-danger-tertiary-active": "var(--Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--Orange-100)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-100)",
      "color-bg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--Green-100)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Gray100)",
      "color-bg-info-secondary": "var(--Blue-100)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--AuForumAssurance_Rouge-brule)",
      "color-bg-decorative-primary-hover": "var(--AuForumAssurance_Rouge-brule)",
      "color-bg-decorative-primary-active": "var(--AuForumAssurance_Rouge-brule)",
      "color-bg-decorative-disable": "rgb(0 0 0 / 0)",
      "color-bg-decorative-secondary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-hover": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-active": "rgb(0 0 0 / 0.1)",
      "color-bg-decorative-tertiary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-1": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-decorative-2": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-decorative-3": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-decorative-4": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-decorative-5": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-neutral": "var(--AuForumAssurance_Ink-900)",
      "color-bg-neutral-inverse": "var(--AuForumAssurance_Cream-200)",
      "color-bg-brand-light": "var(--AuForumAssurance_Rouge-brule)",
      "color-bg-brand": "var(--AuForumAssurance_Cramoisi)",
      "color-bg-brand-dark": "var(--AuForumAssurance_Magenta)",
      "color-fg-base-primary": "var(--White)",
      "color-fg-base-secondary": "var(--AuForumAssurance_Ink-900)",
      "color-fg-base-tertiary": "var(--White)",
      "color-fg-base-active": "var(--White)",
      "color-fg-base-disable": "var(--Gray400)",
      "color-fg-base": "var(--AuForumAssurance_Ink-900)",
      "color-fg-base-focus": "var(--AuForumAssurance_Rouge-brule)",
      "color-fg-base-inverse": "var(--White)",
      "color-fg-base-active-inverse": "var(--AuForumAssurance_Rouge-brule)",
      "color-fg-danger-primary": "var(--White)",
      "color-fg-danger": "var(--Red-500)",
      "color-fg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-danger-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-success-primary": "var(--White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-success-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-warning-primary": "var(--White)",
      "color-fg-warning": "var(--Orange-500)",
      "color-fg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-warning-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-info-primary": "var(--White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-info-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative": "var(--AuForumAssurance_Cream-50)",
      "color-fg-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative-primary": "var(--White)",
      "color-fg-decorative-secondary": "var(--White)",
      "color-fg-decorative-tertiary": "var(--White)",
      "color-stroke-base-input": "var(--Gray300)",
      "color-stroke-base-input-hover": "var(--Gray400)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--AuForumAssurance_Orange-chaud)",
      "color-stroke-base-input-focus": "var(--AuForumAssurance_Rouge-brule)",
      "color-stroke-base-main-highlight": "rgb(232 117 26 / 0.25)",
      "color-stroke-base-basic": "var(--Gray200)",
      "color-stroke-base-main": "var(--AuForumAssurance_Cream-200)",
      "color-stroke-base-main-hover": "var(--AuForumAssurance_Cream-300)",
      "color-stroke-base-main-active": "var(--AuForumAssurance_Cream-300)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--AuForumAssurance_Orange-chaud)",
      "color-stroke-base-input-highlight": "var(--AuForumAssurance_Orange-chaud)",
      "color-stroke-danger": "var(--Red-500)",
      "color-stroke-danger-hover": "var(--Red-600)",
      "color-stroke-danger-active": "var(--Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "rgb(0 0 0 / 0.15)",
      "color-stroke-decorative-hover": "rgb(0 0 0 / 0.25)",
      "color-stroke-decorative-active": "rgb(0 0 0 / 0.5)",
      "color-stroke-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-base-tertiary": "var(--White)",
      "color-text-base-primary": "var(--White)",
      "color-text-base-secondary": "var(--AuForumAssurance_Ink-900)",
      "color-text-base-main": "var(--AuForumAssurance_Ink-900)",
      "color-text-base-basic": "var(--AuForumAssurance_Ink-700)",
      "color-text-base-disable": "var(--AuForumAssurance_Ink-500)",
      "color-text-base-link": "var(--AuForumAssurance_Orange-chaud)",
      "color-text-base-inverse": "var(--AuForumAssurance_Cream-50)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Red-500)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--White)",
      "color-text-decorative-tertiary": "var(--White)",
      "color-text-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-decorative-main": "var(--White)",
      "color-text-decorative-basic": "var(--White)",
      "color-text-decorative-primary": "var(--White)",
      "color-text-decorative-1": "var(--White)",
      "color-text-decorative-2": "var(--White)",
      "color-text-decorative-3": "var(--White)",
      "color-text-decorative-4": "var(--White)",
      "color-text-decorative-5": "var(--White)",
      "color-background-subtle": "var(--AuForumAssurance_Cream-100)"
    },
    "dealt": {
      "color-background": "var(--Dealt_White)",
      "color-bg-base-primary": "var(--Dealt_Black)",
      "color-bg-base-primary-hover": "var(--Gray800)",
      "color-bg-base-primary-active": "var(--Gray800)",
      "color-bg-base-secondary": "var(--Dealt_White)",
      "color-bg-base-secondary-active": "var(--Gray100)",
      "color-bg-base-secondary-hover": "var(--Gray100)",
      "color-bg-base-tertiary": "var(--Gray100)",
      "color-bg-base-tertiary-hover": "var(--Gray100)",
      "color-bg-base-tertiary-active": "var(--Gray200)",
      "color-bg-base-normal": "var(--Dealt_White)",
      "color-bg-base-normal-subtle": "var(--Gray50)",
      "color-bg-base-active": "var(--Dealt_Primary)",
      "color-bg-base-disable": "var(--Gray200)",
      "color-bg-base-hover": "var(--Gray100)",
      "color-bg-base-focus": "var(--Gray100)",
      "color-bg-base-active-disable": "var(--Gray300)",
      "color-bg-base-inverse": "var(--Dealt_Black)",
      "color-bg-base-highlight": "var(--Dealt_Primary-light)",
      "color-bg-danger-primary": "var(--Dealt_Red-500)",
      "color-bg-danger-primary-hover": "var(--Dealt_Red-600)",
      "color-bg-danger-primary-active": "var(--Dealt_Red-600)",
      "color-bg-danger-primary-disable": "var(--Dealt_Red-600)",
      "color-bg-danger-inverse": "var(--Dealt_Red-200)",
      "color-bg-danger-secondary": "var(--Dealt_White)",
      "color-bg-danger-secondary-hover": "var(--Dealt_Red-100)",
      "color-bg-danger-secondary-active": "var(--Dealt_Red-100)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Dealt_Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Dealt_Red-200)",
      "color-bg-danger-tertiary-active": "var(--Dealt_Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--Dealt_White)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--Dealt_White)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Gray100)",
      "color-bg-info-secondary": "var(--Dealt_White)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--Dealt_Black)",
      "color-bg-decorative-primary-hover": "var(--Gray800)",
      "color-bg-decorative-primary-active": "var(--Gray800)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000d",
      "color-bg-decorative-active": "#0000001a",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Dealt_Primary-light-2)",
      "color-bg-decorative-2": "var(--Dealt_Primary-light-2)",
      "color-bg-decorative-3": "var(--Dealt_Primary-light-2)",
      "color-bg-decorative-4": "var(--Dealt_Primary-light-2)",
      "color-bg-decorative-5": "var(--Dealt_Primary-light-2)",
      "color-bg-neutral": "var(--Dealt_Black)",
      "color-bg-neutral-inverse": "var(--Gray100)",
      "color-bg-brand-light": "var(--Dealt_Primary-light-2)",
      "color-bg-brand": "var(--Dealt_Primary-light-2)",
      "color-bg-brand-dark": "var(--Dealt_Primary-light-2)",
      "color-fg-base-primary": "var(--Dealt_White)",
      "color-fg-base-secondary": "var(--Dealt_Black)",
      "color-fg-base-tertiary": "var(--Dealt_Black)",
      "color-fg-base-active": "var(--Dealt_White)",
      "color-fg-base-disable": "var(--Gray400)",
      "color-fg-base": "var(--Dealt_Black)",
      "color-fg-base-focus": "var(--Dealt_Black)",
      "color-fg-base-inverse": "var(--Dealt_White)",
      "color-fg-base-active-inverse": "var(--Dealt_Black)",
      "color-fg-danger-primary": "var(--Dealt_White)",
      "color-fg-danger": "var(--Dealt_Red-500)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Dealt_White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Dealt_White)",
      "color-fg-warning": "var(--Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Dealt_White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Dealt_Black)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--Dealt_White)",
      "color-fg-decorative-secondary": "var(--Dealt_Black)",
      "color-fg-decorative-tertiary": "var(--Dealt_Black)",
      "color-stroke-base-input": "var(--Gray400)",
      "color-stroke-base-input-hover": "var(--Gray500)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Dealt_Primary)",
      "color-stroke-base-input-focus": "var(--Dealt_Black)",
      "color-stroke-base-main-highlight": "var(--Dealt_Primary-light)",
      "color-stroke-base-basic": "var(--Gray300)",
      "color-stroke-base-main": "var(--Gray300)",
      "color-stroke-base-main-hover": "var(--Gray400)",
      "color-stroke-base-main-active": "var(--Gray500)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Dealt_Primary)",
      "color-stroke-base-input-highlight": "var(--Dealt_Primary-light)",
      "color-stroke-danger": "var(--Dealt_Red-500)",
      "color-stroke-danger-hover": "var(--Dealt_Red-600)",
      "color-stroke-danger-active": "var(--Dealt_Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Dealt_Black)",
      "color-text-base-primary": "var(--Dealt_White)",
      "color-text-base-secondary": "var(--Dealt_Black)",
      "color-text-base-main": "var(--Dealt_Black)",
      "color-text-base-basic": "var(--Dealt_Black)",
      "color-text-base-disable": "var(--Gray500)",
      "color-text-base-link": "var(--Dealt_Primary)",
      "color-text-base-inverse": "var(--Dealt_White)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Dealt_Red-600)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--Dealt_Black)",
      "color-text-decorative-tertiary": "var(--Dealt_Black)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Dealt_Black)",
      "color-text-decorative-basic": "var(--Dealt_Black)",
      "color-text-decorative-primary": "var(--Dealt_White)",
      "color-text-decorative-1": "var(--Dealt_Primary-light-2)",
      "color-text-decorative-2": "var(--Dealt_Primary-light-2)",
      "color-text-decorative-3": "var(--Dealt_Primary-light-2)",
      "color-text-decorative-4": "var(--Dealt_Primary-light-2)",
      "color-text-decorative-5": "var(--Dealt_Primary-light-2)"
    },
    "dougs": {
      "color-background": "var(--Legacy-White)",
      "color-bg-base-primary": "var(--Dougs_Blue-400)",
      "color-bg-base-primary-hover": "var(--Dougs_Blue-400)",
      "color-bg-base-primary-active": "var(--Dougs_Blue-400)",
      "color-bg-base-secondary": "var(--Legacy-White)",
      "color-bg-base-secondary-active": "var(--Legacy-White)",
      "color-bg-base-secondary-hover": "var(--Legacy-White)",
      "color-bg-base-tertiary": "var(--Dougs_Blue-200)",
      "color-bg-base-tertiary-hover": "var(--Dougs_Blue-200)",
      "color-bg-base-tertiary-active": "var(--Dougs_Blue-200)",
      "color-bg-base-normal": "var(--Legacy-White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Dougs_Blue-400)",
      "color-bg-base-disable": "var(--Legacy-Gray-200)",
      "color-bg-base-hover": "var(--Legacy-Blue-100)",
      "color-bg-base-focus": "var(--Legacy-Blue-100)",
      "color-bg-base-active-disable": "var(--Legacy-Gray-300)",
      "color-bg-base-inverse": "var(--Legacy-Black)",
      "color-bg-base-highlight": "#11ABEC80",
      "color-bg-danger-primary": "var(--Legacy-Red-600)",
      "color-bg-danger-primary-hover": "var(--Legacy-Red-700)",
      "color-bg-danger-primary-active": "var(--Legacy-Red-800)",
      "color-bg-danger-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-danger-inverse": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary": "var(--Legacy-White)",
      "color-bg-danger-secondary-hover": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary-active": "var(--Legacy-Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Legacy-Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Legacy-Red-200)",
      "color-bg-danger-tertiary-active": "var(--Legacy-Red-300)",
      "color-bg-warning-primary": "var(--Legacy-Orange-600)",
      "color-bg-warning-primary-hover": "var(--Legacy-Orange-700)",
      "color-bg-warning-primary-active": "var(--Legacy-Orange-800)",
      "color-bg-warning-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-warning-inverse": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary": "var(--Legacy-White)",
      "color-bg-warning-secondary-hover": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary-active": "var(--Legacy-Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Legacy-Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Legacy-Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Legacy-Orange-300)",
      "color-bg-success-primary": "var(--Legacy-Green-600)",
      "color-bg-success-primary-hover": "var(--Legacy-Green-700)",
      "color-bg-success-primary-active": "var(--Legacy-Green-800)",
      "color-bg-success-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-success-inverse": "var(--Legacy-Green-100)",
      "color-bg-success-secondary": "var(--Legacy-White)",
      "color-bg-success-secondary-hover": "var(--Legacy-Green-100)",
      "color-bg-success-secondary-active": "var(--Legacy-Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Legacy-Green-100)",
      "color-bg-success-tertiary-hover": "var(--Legacy-Green-200)",
      "color-bg-success-tertiary-active": "var(--Legacy-Green-300)",
      "color-bg-info-inverse": "var(--Legacy-Blue-200)",
      "color-bg-info-primary": "var(--Legacy-Blue-600)",
      "color-bg-info-primary-hover": "var(--Legacy-Blue-700)",
      "color-bg-info-primary-active": "var(--Legacy-Blue-800)",
      "color-bg-info-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-info-secondary": "var(--Legacy-White)",
      "color-bg-info-secondary-hover": "var(--Legacy-Blue-100)",
      "color-bg-info-secondary-active": "var(--Legacy-Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Legacy-Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Legacy-Blue-200)",
      "color-bg-info-tertiary-active": "var(--Legacy-Blue-300)",
      "color-bg-decorative-primary": "var(--Dougs_Blue-400)",
      "color-bg-decorative-primary-hover": "var(--Dougs_Blue-400)",
      "color-bg-decorative-primary-active": "var(--Dougs_Blue-400)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000D",
      "color-bg-decorative-active": "#0000001A",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Dougs_Blue-100)",
      "color-bg-decorative-2": "var(--Dougs_Blue-100)",
      "color-bg-decorative-3": "var(--Dougs_Blue-100)",
      "color-bg-decorative-4": "var(--Dougs_Blue-100)",
      "color-bg-decorative-5": "var(--Dougs_Blue-100)",
      "color-bg-neutral": "var(--Legacy-Gray-800)",
      "color-bg-neutral-inverse": "var(--Legacy-Gray-100)",
      "color-bg-brand-light": "var(--Dougs_Blue-100)",
      "color-bg-brand": "var(--Dougs_Blue-100)",
      "color-bg-brand-dark": "var(--Dougs_Blue-100)",
      "color-fg-base-primary": "var(--Legacy-White)",
      "color-fg-base-secondary": "var(--Legacy-Black)",
      "color-fg-base-tertiary": "var(--Legacy-Black)",
      "color-fg-base-active": "var(--Legacy-White)",
      "color-fg-base-disable": "var(--Legacy-Gray-400)",
      "color-fg-base": "var(--Legacy-Black)",
      "color-fg-base-focus": "var(--Legacy-Black)",
      "color-fg-base-inverse": "var(--Legacy-White)",
      "color-fg-base-active-inverse": "var(--Dougs_Blue-400)",
      "color-fg-danger-primary": "var(--Legacy-White)",
      "color-fg-danger": "var(--Legacy-Red-600)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Legacy-White)",
      "color-fg-success": "var(--Legacy-Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Legacy-White)",
      "color-fg-warning": "var(--Legacy-Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Legacy-White)",
      "color-fg-info": "var(--Legacy-Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Dougs_Blue-500)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--Legacy-White)",
      "color-fg-decorative-secondary": "var(--Dougs_Blue-500)",
      "color-fg-decorative-tertiary": "var(--Dougs_Blue-500)",
      "color-stroke-base-input": "var(--Gray400)",
      "color-stroke-base-input-hover": "var(--Gray500)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Dougs_Blue-400)",
      "color-stroke-base-input-focus": "var(--Gray800)",
      "color-stroke-base-main-highlight": "var(--Dougs_Blue-400)",
      "color-stroke-base-basic": "var(--Gray300)",
      "color-stroke-base-main": "var(--Gray300)",
      "color-stroke-base-main-hover": "var(--Gray400)",
      "color-stroke-base-main-active": "var(--Gray500)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Dougs_Blue-400)",
      "color-stroke-base-input-highlight": "var(--Dougs_Blue-400)",
      "color-stroke-danger": "var(--Legacy-Red-600)",
      "color-stroke-danger-hover": "var(--Legacy-Red-700)",
      "color-stroke-danger-active": "var(--Legacy-Red-800)",
      "color-stroke-success": "var(--Legacy-Green-600)",
      "color-stroke-success-hover": "var(--Legacy-Green-700)",
      "color-stroke-success-active": "var(--Legacy-Green-800)",
      "color-stroke-warning": "var(--Legacy-Orange-600)",
      "color-stroke-warning-hover": "var(--Legacy-Orange-700)",
      "color-stroke-warning-active": "var(--Legacy-Orange-800)",
      "color-stroke-info": "var(--Legacy-Blue-600)",
      "color-stroke-info-hover": "var(--Legacy-Blue-700)",
      "color-stroke-info-active": "var(--Legacy-Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Legacy-Black)",
      "color-text-base-primary": "var(--Legacy-White)",
      "color-text-base-secondary": "var(--Legacy-Black)",
      "color-text-base-main": "var(--Legacy-Black)",
      "color-text-base-basic": "var(--Legacy-Black)",
      "color-text-base-disable": "var(--Legacy-Gray-400)",
      "color-text-base-link": "var(--Dougs_Blue-400)",
      "color-text-base-inverse": "var(--Legacy-White)",
      "color-text-danger-primary": "var(--Legacy-Red-800)",
      "color-text-danger-secondary": "var(--Legacy-Red-600)",
      "color-text-success-primary": "var(--Legacy-Green-800)",
      "color-text-success-secondary": "var(--Legacy-Green-600)",
      "color-text-warning-primary": "var(--Legacy-Orange-800)",
      "color-text-warning-secondary": "var(--Legacy-Orange-600)",
      "color-text-info-primary": "var(--Legacy-Blue-800)",
      "color-text-info-secondary": "var(--Legacy-Blue-600)",
      "color-text-decorative-secondary": "var(--Dougs_Blue-500)",
      "color-text-decorative-tertiary": "var(--Dougs_Blue-500)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Dougs_Blue-500)",
      "color-text-decorative-basic": "var(--Dougs_Blue-500)",
      "color-text-decorative-primary": "var(--Legacy-White)",
      "color-text-decorative-1": "var(--Dougs_Blue-100)",
      "color-text-decorative-2": "var(--Dougs_Blue-100)",
      "color-text-decorative-3": "var(--Dougs_Blue-100)",
      "color-text-decorative-4": "var(--Dougs_Blue-100)",
      "color-text-decorative-5": "var(--Dougs_Blue-100)"
    },
    "indy": {
      "color-background": "var(--Indy_White)",
      "color-bg-base-primary": "var(--Indy_Pink-20)",
      "color-bg-base-primary-hover": "var(--Indy_Pink-40)",
      "color-bg-base-primary-active": "var(--Indy_Pink-40)",
      "color-bg-base-secondary": "var(--Indy_White)",
      "color-bg-base-secondary-active": "var(--Indy_Grey-100)",
      "color-bg-base-secondary-hover": "var(--Indy_Grey-100)",
      "color-bg-base-tertiary": "var(--Indy_Grey-100)",
      "color-bg-base-tertiary-hover": "var(--Indy_Grey-80)",
      "color-bg-base-tertiary-active": "var(--Indy_Grey-80)",
      "color-bg-base-normal": "var(--Indy_White)",
      "color-bg-base-active": "var(--Indy_Pink-20)",
      "color-bg-base-disable": "var(--Indy_Grey-80)",
      "color-bg-base-hover": "var(--Indy_Grey-100)",
      "color-bg-base-focus": "var(--Indy_Grey-100)",
      "color-bg-base-active-disable": "var(--Indy_Grey-60)",
      "color-bg-base-inverse": "var(--Indy_Grey-0)",
      "color-bg-base-highlight": "var(--Indy_Pink-100)",
      "color-bg-base-normal-subtle": "var(--Indy_White)",
      "color-bg-danger-primary": "var(--Indy_Red-20)",
      "color-bg-danger-primary-hover": "var(--Indy_Red-20)",
      "color-bg-danger-primary-active": "var(--Indy_Red-20)",
      "color-bg-danger-primary-disable": "var(--Indy_Red-100)",
      "color-bg-danger-inverse": "var(--Indy_Red-100)",
      "color-bg-danger-secondary": "var(--Indy_White)",
      "color-bg-danger-secondary-hover": "var(--Indy_Red-100)",
      "color-bg-danger-secondary-active": "var(--Indy_Red-100)",
      "color-bg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-danger-tertiary": "var(--Indy_Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Indy_Red-100)",
      "color-bg-danger-tertiary-active": "var(--Indy_Red-100)",
      "color-bg-warning-primary": "var(--Indy_Orange-20)",
      "color-bg-warning-primary-hover": "var(--Indy_Orange-20)",
      "color-bg-warning-primary-active": "var(--Indy_Orange-20)",
      "color-bg-warning-primary-disable": "var(--Indy_Orange-100)",
      "color-bg-warning-inverse": "var(--Indy_Orange-100)",
      "color-bg-warning-secondary": "var(--Indy_White)",
      "color-bg-warning-secondary-hover": "var(--Indy_Orange-100)",
      "color-bg-warning-secondary-active": "var(--Indy_Orange-100)",
      "color-bg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-warning-tertiary": "var(--Indy_Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Indy_Orange-100)",
      "color-bg-warning-tertiary-active": "var(--Indy_Orange-100)",
      "color-bg-success-primary": "var(--Indy_Teal-20)",
      "color-bg-success-primary-hover": "var(--Indy_Teal-20)",
      "color-bg-success-primary-active": "var(--Indy_Teal-20)",
      "color-bg-success-primary-disable": "var(--Indy_Teal-100)",
      "color-bg-success-inverse": "var(--Indy_Teal-100)",
      "color-bg-success-secondary": "var(--Indy_White)",
      "color-bg-success-secondary-hover": "var(--Indy_Teal-100)",
      "color-bg-success-secondary-active": "var(--Indy_Teal-100)",
      "color-bg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-success-tertiary": "var(--Indy_Teal-100)",
      "color-bg-success-tertiary-hover": "var(--Indy_Teal-100)",
      "color-bg-success-tertiary-active": "var(--Indy_Teal-100)",
      "color-bg-info-inverse": "var(--Indy_Blue-100)",
      "color-bg-info-primary": "var(--Indy_Blue-20)",
      "color-bg-info-primary-hover": "var(--Indy_Blue-20)",
      "color-bg-info-primary-active": "var(--Indy_Blue-20)",
      "color-bg-info-primary-disable": "var(--Indy_Blue-100)",
      "color-bg-info-secondary": "var(--Indy_White)",
      "color-bg-info-secondary-hover": "var(--Indy_Blue-100)",
      "color-bg-info-secondary-active": "var(--Indy_Blue-100)",
      "color-bg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-info-tertiary": "var(--Indy_Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Indy_Blue-100)",
      "color-bg-info-tertiary-active": "var(--Indy_Blue-100)",
      "color-bg-decorative-primary": "var(--Indy_White)",
      "color-bg-decorative-primary-hover": "var(--Indy_White)",
      "color-bg-decorative-primary-active": "var(--Indy_White)",
      "color-bg-decorative-disable": "rgb(0 0 0 / 0)",
      "color-bg-decorative-secondary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-hover": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-active": "rgb(0 0 0 / 0.1)",
      "color-bg-decorative-tertiary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-1": "var(--Indy_Beige-100)",
      "color-bg-decorative-2": "var(--Indy_Beige-100)",
      "color-bg-decorative-3": "var(--Indy_Beige-100)",
      "color-bg-decorative-4": "var(--Indy_Beige-100)",
      "color-bg-decorative-5": "var(--Indy_Beige-100)",
      "color-bg-neutral": "var(--Indy_Black-100)",
      "color-bg-neutral-inverse": "var(--Indy_Grey-100)",
      "color-bg-brand-light": "var(--Indy_Pink-100)",
      "color-bg-brand": "var(--Indy_Beige-100)",
      "color-bg-brand-dark": "var(--Indy_Beige-100)",
      "color-fg-base-primary": "var(--Indy_White)",
      "color-fg-base-secondary": "var(--Indy_Black-100)",
      "color-fg-base-tertiary": "var(--Indy_Black-100)",
      "color-fg-base-active": "var(--Indy_White)",
      "color-fg-base-disable": "var(--Indy_Grey-60)",
      "color-fg-base": "var(--Indy_Black-100)",
      "color-fg-base-focus": "var(--Indy_Black-100)",
      "color-fg-base-inverse": "var(--Indy_White)",
      "color-fg-base-active-inverse": "var(--Indy_Black-100)",
      "color-fg-danger-primary": "var(--Indy_Red-100)",
      "color-fg-danger": "var(--Indy_Red-20)",
      "color-fg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-danger-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-success-primary": "var(--Indy_Teal-100)",
      "color-fg-success": "var(--Indy_Teal-20)",
      "color-fg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-success-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-warning-primary": "var(--Indy_Orange-100)",
      "color-fg-warning": "var(--Indy_Orange-20)",
      "color-fg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-warning-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-info-primary": "var(--Indy_Blue-100)",
      "color-fg-info": "var(--Indy_Blue-20)",
      "color-fg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-info-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative": "var(--Indy_Black-100)",
      "color-fg-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative-primary": "var(--Indy_Black-100)",
      "color-fg-decorative-secondary": "var(--Indy_Black-100)",
      "color-fg-decorative-tertiary": "var(--Indy_Black-100)",
      "color-stroke-base-input": "var(--Indy_Grey-60)",
      "color-stroke-base-input-hover": "var(--Indy_Grey-40)",
      "color-stroke-base-input-active": "var(--Indy_Grey-40)",
      "color-stroke-base-input-disable": "var(--Indy_Grey-100)",
      "color-stroke-base-main-selected": "var(--Indy_Grey-40)",
      "color-stroke-base-input-focus": "var(--Indy_Grey-20)",
      "color-stroke-base-main-highlight": "var(--Indy_Grey-20)",
      "color-stroke-base-basic": "var(--Indy_Grey-80)",
      "color-stroke-base-main": "var(--Indy_Grey-80)",
      "color-stroke-base-main-hover": "var(--Indy_Grey-40)",
      "color-stroke-base-main-active": "var(--Indy_Grey-20)",
      "color-stroke-base-main-disable": "var(--Indy_Grey-80)",
      "color-stroke-base-input-selected": "var(--Indy_Grey-20)",
      "color-stroke-base-input-highlight": "rgb(0 0 0 / 0)",
      "color-stroke-danger": "var(--Indy_Red-20)",
      "color-stroke-danger-hover": "var(--Indy_Red-20)",
      "color-stroke-danger-active": "var(--Indy_Red-20)",
      "color-stroke-success": "var(--Indy_Teal-20)",
      "color-stroke-success-hover": "var(--Indy_Teal-20)",
      "color-stroke-success-active": "var(--Indy_Teal-20)",
      "color-stroke-warning": "var(--Indy_Orange-20)",
      "color-stroke-warning-hover": "var(--Indy_Orange-20)",
      "color-stroke-warning-active": "var(--Indy_Orange-20)",
      "color-stroke-info": "var(--Indy_Blue-20)",
      "color-stroke-info-hover": "var(--Indy_Blue-20)",
      "color-stroke-info-active": "var(--Indy_Blue-20)",
      "color-stroke-decorative": "rgb(0 0 0 / 0.15)",
      "color-stroke-decorative-hover": "rgb(0 0 0 / 0.25)",
      "color-stroke-decorative-active": "rgb(0 0 0 / 0.5)",
      "color-stroke-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-base-tertiary": "var(--Indy_Black-100)",
      "color-text-base-primary": "var(--Indy_White)",
      "color-text-base-secondary": "var(--Indy_Black-100)",
      "color-text-base-main": "var(--Indy_Black-100)",
      "color-text-base-basic": "var(--Indy_Grey-0)",
      "color-text-base-disable": "var(--Indy_Grey-60)",
      "color-text-base-link": "var(--Indy_Pink-20)",
      "color-text-base-inverse": "var(--Indy_White)",
      "color-text-danger-primary": "var(--Indy_Red-20)",
      "color-text-danger-secondary": "var(--Indy_Red-20)",
      "color-text-success-primary": "var(--Indy_Teal-20)",
      "color-text-success-secondary": "var(--Indy_Teal-20)",
      "color-text-warning-primary": "var(--Indy_Orange-20)",
      "color-text-warning-secondary": "var(--Indy_Orange-20)",
      "color-text-info-primary": "var(--Indy_Blue-20)",
      "color-text-info-secondary": "var(--Indy_Blue-20)",
      "color-text-decorative-secondary": "var(--Indy_Grey-0)",
      "color-text-decorative-tertiary": "var(--Indy_Grey-0)",
      "color-text-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-decorative-main": "var(--Indy_Grey-0)",
      "color-text-decorative-basic": "var(--Indy_Grey-0)",
      "color-text-decorative-primary": "var(--Indy_Grey-0)",
      "color-text-decorative-1": "var(--Indy_Beige-100)",
      "color-text-decorative-2": "var(--Indy_Beige-100)",
      "color-text-decorative-3": "var(--Indy_Beige-100)",
      "color-text-decorative-4": "var(--Indy_Beige-100)",
      "color-text-decorative-5": "var(--Indy_Beige-100)"
    },
    "jump": {
      "color-background": "var(--Jump_Neutral-000)",
      "color-bg-base-primary": "var(--Jump_Identity-900)",
      "color-bg-base-primary-hover": "var(--Jump_Identity-500)",
      "color-bg-base-primary-active": "var(--Jump_Identity-500)",
      "color-bg-base-secondary": "var(--Jump_Neutral-000)",
      "color-bg-base-secondary-active": "var(--Jump_Neutral-000)",
      "color-bg-base-secondary-hover": "var(--Jump_Neutral-000)",
      "color-bg-base-tertiary": "var(--Jump_Positive-100)",
      "color-bg-base-tertiary-hover": "var(--Jump_Positive-200)",
      "color-bg-base-tertiary-active": "var(--Jump_Positive-400)",
      "color-bg-base-normal": "var(--Jump_Neutral-000)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Jump_Positive-400)",
      "color-bg-base-disable": "var(--Legacy-Gray-300)",
      "color-bg-base-hover": "var(--Jump_Gray-200)",
      "color-bg-base-focus": "var(--Jump_Gray-200)",
      "color-bg-base-active-disable": "var(--Legacy-Gray-400)",
      "color-bg-base-inverse": "var(--Jump_Gray-900)",
      "color-bg-base-highlight": "#1CD3DF80",
      "color-bg-danger-primary": "var(--Legacy-Red-600)",
      "color-bg-danger-primary-hover": "var(--Legacy-Red-700)",
      "color-bg-danger-primary-active": "var(--Legacy-Red-800)",
      "color-bg-danger-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-danger-inverse": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary": "var(--Jump_Neutral-000)",
      "color-bg-danger-secondary-hover": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary-active": "var(--Legacy-Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Legacy-Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Legacy-Red-200)",
      "color-bg-danger-tertiary-active": "var(--Legacy-Red-300)",
      "color-bg-warning-primary": "var(--Legacy-Orange-600)",
      "color-bg-warning-primary-hover": "var(--Legacy-Orange-700)",
      "color-bg-warning-primary-active": "var(--Legacy-Orange-800)",
      "color-bg-warning-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-warning-inverse": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary": "var(--Legacy-White)",
      "color-bg-warning-secondary-hover": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary-active": "var(--Legacy-Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Legacy-Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Legacy-Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Legacy-Orange-300)",
      "color-bg-success-primary": "var(--Legacy-Green-600)",
      "color-bg-success-primary-hover": "var(--Legacy-Green-700)",
      "color-bg-success-primary-active": "var(--Legacy-Green-800)",
      "color-bg-success-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-success-inverse": "var(--Legacy-Green-100)",
      "color-bg-success-secondary": "var(--Jump_Neutral-000)",
      "color-bg-success-secondary-hover": "var(--Legacy-Green-100)",
      "color-bg-success-secondary-active": "var(--Legacy-Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Legacy-Green-100)",
      "color-bg-success-tertiary-hover": "var(--Legacy-Green-200)",
      "color-bg-success-tertiary-active": "var(--Legacy-Green-300)",
      "color-bg-info-inverse": "var(--Legacy-Blue-200)",
      "color-bg-info-primary": "var(--Legacy-Blue-600)",
      "color-bg-info-primary-hover": "var(--Legacy-Blue-700)",
      "color-bg-info-primary-active": "var(--Legacy-Blue-800)",
      "color-bg-info-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-info-secondary": "var(--Jump_Neutral-000)",
      "color-bg-info-secondary-hover": "var(--Legacy-Blue-100)",
      "color-bg-info-secondary-active": "var(--Legacy-Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Legacy-Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Legacy-Blue-200)",
      "color-bg-info-tertiary-active": "var(--Legacy-Blue-300)",
      "color-bg-decorative-primary": "var(--Jump_Neutral-000)",
      "color-bg-decorative-primary-hover": "var(--Legacy-Gray-100)",
      "color-bg-decorative-primary-active": "var(--Legacy-Gray-200)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000D",
      "color-bg-decorative-active": "#0000001A",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Jump_Positive-100)",
      "color-bg-decorative-2": "var(--Jump_Positive-100)",
      "color-bg-decorative-3": "var(--Jump_Positive-100)",
      "color-bg-decorative-4": "var(--Jump_Positive-100)",
      "color-bg-decorative-5": "var(--Jump_Positive-100)",
      "color-bg-neutral": "var(--Jump_Neutral-700)",
      "color-bg-neutral-inverse": "var(--Jump_Gray-200)",
      "color-bg-brand-light": "var(--Jump_Positive-100)",
      "color-bg-brand": "var(--Jump_Positive-100)",
      "color-bg-brand-dark": "var(--Jump_Positive-100)",
      "color-fg-base-primary": "var(--Jump_Neutral-000)",
      "color-fg-base-secondary": "var(--Jump_Identity-900)",
      "color-fg-base-tertiary": "var(--Jump_Identity-900)",
      "color-fg-base-active": "var(--Jump_Neutral-000)",
      "color-fg-base-disable": "var(--Legacy-Gray-600)",
      "color-fg-base": "var(--Jump_Identity-900)",
      "color-fg-base-focus": "var(--Jump_Identity-900)",
      "color-fg-base-inverse": "var(--Jump_Neutral-000)",
      "color-fg-base-active-inverse": "var(--Jump_Positive-400)",
      "color-fg-danger-primary": "var(--Jump_Neutral-000)",
      "color-fg-danger": "var(--Legacy-Red-600)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Jump_Neutral-000)",
      "color-fg-success": "var(--Legacy-Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Jump_Neutral-000)",
      "color-fg-warning": "var(--Legacy-Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Jump_Neutral-000)",
      "color-fg-info": "var(--Legacy-Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Jump_Gray-900)",
      "color-fg-decorative-disable": "#00000040",
      "color-stroke-base-input": "var(--Jump_Gray-200)",
      "color-stroke-base-input-hover": "var(--Gray400)",
      "color-stroke-base-input-active": "var(--Jump_Gray-600)",
      "color-stroke-base-input-disable": "var(--Gray400)",
      "color-stroke-base-main-selected": "var(--Jump_Positive-400)",
      "color-stroke-base-input-focus": "var(--Jump_Identity-900)",
      "color-stroke-base-main-highlight": "var(--Jump_Positive-400)",
      "color-stroke-base-basic": "var(--Jump_Gray-200)",
      "color-stroke-base-main": "var(--Jump_Gray-200)",
      "color-stroke-base-main-hover": "var(--Gray400)",
      "color-stroke-base-main-active": "var(--Jump_Gray-600)",
      "color-stroke-base-main-disable": "var(--Gray400)",
      "color-stroke-base-input-selected": "var(--Jump_Positive-400)",
      "color-stroke-base-input-highlight": "var(--Jump_Positive-400)",
      "color-stroke-danger": "var(--Legacy-Red-600)",
      "color-stroke-danger-hover": "var(--Legacy-Red-700)",
      "color-stroke-danger-active": "var(--Legacy-Red-800)",
      "color-stroke-success": "var(--Legacy-Green-600)",
      "color-stroke-success-hover": "var(--Legacy-Green-700)",
      "color-stroke-success-active": "var(--Legacy-Green-800)",
      "color-stroke-warning": "var(--Legacy-Orange-600)",
      "color-stroke-warning-hover": "var(--Legacy-Orange-700)",
      "color-stroke-warning-active": "var(--Legacy-Orange-800)",
      "color-stroke-info": "var(--Legacy-Blue-600)",
      "color-stroke-info-hover": "var(--Legacy-Blue-700)",
      "color-stroke-info-active": "var(--Legacy-Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Jump_Identity-900)",
      "color-text-base-primary": "var(--Jump_Neutral-000)",
      "color-text-base-secondary": "var(--Jump_Identity-900)",
      "color-text-base-main": "var(--Jump_Identity-900)",
      "color-text-base-basic": "var(--Jump_Identity-500)",
      "color-text-base-disable": "var(--Legacy-Gray-600)",
      "color-text-base-link": "var(--Jump_Positive-400)",
      "color-text-danger-primary-inverse": "var(--Legacy-Red-800)",
      "color-text-danger-secondary": "var(--Legacy-Red-600)",
      "color-text-success-primary": "var(--Legacy-Green-800)",
      "color-text-success-secondary": "var(--Legacy-Green-600)",
      "color-text-warning-primary": "var(--Legacy-Orange-800)",
      "color-text-warning-secondary": "var(--Legacy-Orange-600)",
      "color-text-info-primary": "var(--Legacy-Blue-800)",
      "color-text-info-secondary": "var(--Legacy-Blue-600)",
      "color-text-decorative-secondary": "var(--Jump_Identity-900)",
      "color-text-decorative-tertiary": "var(--Jump_Identity-900)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Jump_Identity-500)",
      "color-text-decorative-basic": "var(--Jump_Identity-500)",
      "color-text-decorative-primary": "var(--Jump_Identity-900)",
      "color-text-decorative-1": "var(--Jump_Positive-200)",
      "color-text-decorative-2": "var(--Jump_Positive-200)",
      "color-text-decorative-3": "var(--Jump_Positive-200)",
      "color-text-decorative-4": "var(--Jump_Positive-200)",
      "color-text-decorative-5": "var(--Jump_Positive-200)"
    },
    "legalplace": {
      "color-background": "var(--Legacy-Linen)",
      "color-bg-base-primary": "var(--LP_Blue-500)",
      "color-bg-base-primary-hover": "var(--LP_Blue-600)",
      "color-bg-base-primary-active": "var(--LP_Blue-700)",
      "color-bg-base-secondary": "var(--Legacy-White)",
      "color-bg-base-secondary-active": "var(--LP_Grey-100)",
      "color-bg-base-secondary-hover": "var(--LP_Grey-50)",
      "color-bg-base-tertiary": "var(--LP_Grey-100)",
      "color-bg-base-tertiary-hover": "var(--LP_Grey-150)",
      "color-bg-base-tertiary-active": "var(--LP_Grey-200)",
      "color-bg-base-normal": "var(--Legacy-White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--LP_Blue-500)",
      "color-bg-base-disable": "var(--LP_Grey-150)",
      "color-bg-base-hover": "var(--LP_Grey-50)",
      "color-bg-base-focus": "var(--LP_Grey-100)",
      "color-bg-base-active-disable": "var(--LP_Grey-300)",
      "color-bg-base-inverse": "var(--LP_Blue-900)",
      "color-bg-base-highlight": "#3392FF80",
      "color-bg-danger-primary": "var(--LP_Red-500)",
      "color-bg-danger-primary-hover": "var(--LP_Red-600)",
      "color-bg-danger-primary-active": "var(--LP_Red-700)",
      "color-bg-danger-primary-disable": "var(--LP_Grey-100)",
      "color-bg-danger-inverse": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary": "var(--Legacy-White)",
      "color-bg-danger-secondary-hover": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary-active": "var(--Legacy-Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Legacy-Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Legacy-Red-200)",
      "color-bg-danger-tertiary-active": "var(--Legacy-Red-300)",
      "color-bg-warning-primary": "var(--Legacy-Orange-600)",
      "color-bg-warning-primary-hover": "var(--Legacy-Orange-700)",
      "color-bg-warning-primary-active": "var(--Legacy-Orange-800)",
      "color-bg-warning-primary-disable": "var(--LP_Grey-100)",
      "color-bg-warning-inverse": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary": "var(--Legacy-White)",
      "color-bg-warning-secondary-hover": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary-active": "var(--Legacy-Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Legacy-Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Legacy-Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Legacy-Orange-300)",
      "color-bg-success-primary": "var(--Legacy-Green-600)",
      "color-bg-success-primary-hover": "var(--Legacy-Green-700)",
      "color-bg-success-primary-active": "var(--Legacy-Green-800)",
      "color-bg-success-primary-disable": "var(--LP_Grey-100)",
      "color-bg-success-inverse": "var(--Legacy-Green-100)",
      "color-bg-success-secondary": "var(--Legacy-White)",
      "color-bg-success-secondary-hover": "var(--Legacy-Green-100)",
      "color-bg-success-secondary-active": "var(--Legacy-Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Legacy-Green-100)",
      "color-bg-success-tertiary-hover": "var(--Legacy-Green-200)",
      "color-bg-success-tertiary-active": "var(--Legacy-Green-300)",
      "color-bg-info-inverse": "var(--Legacy-Blue-200)",
      "color-bg-info-primary": "var(--Legacy-Blue-600)",
      "color-bg-info-primary-hover": "var(--Legacy-Blue-700)",
      "color-bg-info-primary-active": "var(--Legacy-Blue-800)",
      "color-bg-info-primary-disable": "var(--LP_Grey-100)",
      "color-bg-info-secondary": "var(--Legacy-White)",
      "color-bg-info-secondary-hover": "var(--Legacy-Blue-100)",
      "color-bg-info-secondary-active": "var(--Legacy-Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Legacy-Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Legacy-Blue-200)",
      "color-bg-info-tertiary-active": "var(--Legacy-Blue-300)",
      "color-bg-decorative-primary": "var(--Legacy-White)",
      "color-bg-decorative-primary-hover": "var(--LP_Grey-100)",
      "color-bg-decorative-primary-active": "var(--LP_Grey-150)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000D",
      "color-bg-decorative-active": "#0000001A",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--LP_Decorative)",
      "color-bg-decorative-2": "var(--LP_Decorative)",
      "color-bg-decorative-3": "var(--LP_Decorative)",
      "color-bg-decorative-4": "var(--LP_Decorative)",
      "color-bg-decorative-5": "var(--LP_Decorative)",
      "color-bg-neutral": "var(--LP_Grey-600)",
      "color-bg-neutral-inverse": "var(--LP_Grey-100)",
      "color-bg-brand-light": "var(--LP_Decorative)",
      "color-bg-brand": "var(--LP_Decorative)",
      "color-bg-brand-dark": "var(--LP_Decorative)",
      "color-fg-base-primary": "var(--Legacy-White)",
      "color-fg-base-secondary": "var(--LP_Blue-900)",
      "color-fg-base-tertiary": "var(--LP_Blue-500)",
      "color-fg-base-active": "var(--Legacy-White)",
      "color-fg-base-disable": "var(--LP_Grey-300)",
      "color-fg-base": "var(--LP_Blue-900)",
      "color-fg-base-focus": "var(--LP_Blue-900)",
      "color-fg-base-inverse": "var(--Legacy-White)",
      "color-fg-base-active-inverse": "var(--LP_Blue-900)",
      "color-fg-danger-primary": "var(--Legacy-White)",
      "color-fg-danger": "var(--LP_Red-500)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Legacy-White)",
      "color-fg-success": "var(--Legacy-Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Legacy-White)",
      "color-fg-warning": "var(--Legacy-Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Legacy-White)",
      "color-fg-info": "var(--Legacy-Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--LP_Blue-900)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--LP_Blue-900)",
      "color-fg-decorative-secondary": "var(--LP_Blue-900)",
      "color-fg-decorative-tertiary": "var(--LP_Blue-900)",
      "color-stroke-base-input": "var(--LP_Grey-200)",
      "color-stroke-base-input-hover": "var(--LP_Grey-200)",
      "color-stroke-base-input-active": "var(--LP_Grey-300)",
      "color-stroke-base-input-disable": "var(--LP_Grey-200)",
      "color-stroke-base-main-selected": "var(--LP_Blue-500)",
      "color-stroke-base-input-focus": "var(--LP_Grey-600)",
      "color-stroke-base-main-highlight": "var(--LP_Blue-500)",
      "color-stroke-base-basic": "var(--LP_Grey-200)",
      "color-stroke-base-main": "var(--LP_Grey-200)",
      "color-stroke-base-main-hover": "var(--LP_Grey-200)",
      "color-stroke-base-main-active": "var(--LP_Grey-600)",
      "color-stroke-base-main-disable": "var(--LP_Grey-200)",
      "color-stroke-base-input-selected": "var(--LP_Blue-500)",
      "color-stroke-base-input-highlight": "var(--LP_Blue-500)",
      "color-stroke-danger": "var(--Legacy-Red-600)",
      "color-stroke-danger-hover": "var(--Legacy-Red-700)",
      "color-stroke-danger-active": "var(--Legacy-Red-800)",
      "color-stroke-success": "var(--Legacy-Green-600)",
      "color-stroke-success-hover": "var(--Legacy-Green-700)",
      "color-stroke-success-active": "var(--Legacy-Green-800)",
      "color-stroke-warning": "var(--Legacy-Orange-600)",
      "color-stroke-warning-hover": "var(--Legacy-Orange-700)",
      "color-stroke-warning-active": "var(--Legacy-Orange-800)",
      "color-stroke-info": "var(--Legacy-Blue-600)",
      "color-stroke-info-hover": "var(--Legacy-Blue-700)",
      "color-stroke-info-active": "var(--Legacy-Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--LP_Blue-500)",
      "color-text-base-primary": "var(--Legacy-White)",
      "color-text-base-secondary": "var(--LP_Blue-900)",
      "color-text-base-main": "var(--LP_Blue-900)",
      "color-text-base-basic": "var(--LP_Grey-600)",
      "color-text-base-disable": "var(--LP_Grey-300)",
      "color-text-base-link": "var(--LP_Blue-500)",
      "color-text-base-inverse": "var(--Legacy-White)",
      "color-text-danger-primary": "var(--Legacy-Red-800)",
      "color-text-danger-secondary": "var(--Legacy-Red-600)",
      "color-text-success-primary": "var(--Legacy-Green-800)",
      "color-text-success-secondary": "var(--Legacy-Green-600)",
      "color-text-warning-primary": "var(--Legacy-Orange-800)",
      "color-text-warning-secondary": "var(--Legacy-Orange-600)",
      "color-text-info-primary": "var(--Legacy-Blue-800)",
      "color-text-info-secondary": "var(--Legacy-Blue-600)",
      "color-text-decorative-secondary": "var(--LP_Blue-900)",
      "color-text-decorative-tertiary": "var(--LP_Blue-900)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--LP_Blue-900)",
      "color-text-decorative-basic": "var(--LP_Blue-900)",
      "color-text-decorative-primary": "var(--LP_Blue-900)",
      "color-text-decorative-1": "var(--LP_Orange-100)",
      "color-text-decorative-2": "var(--LP_Orange-100)",
      "color-text-decorative-3": "var(--LP_Orange-100)",
      "color-text-decorative-4": "var(--LP_Orange-100)",
      "color-text-decorative-5": "var(--LP_Orange-100)"
    },
    "legalstart": {
      "color-background": "var(--Legalstart_LS-white)",
      "color-bg-base-primary": "var(--Legalstart_LS-dark-blue)",
      "color-bg-base-primary-hover": "var(--Legalstart_LS-dark-blue)",
      "color-bg-base-primary-active": "var(--Legalstart_LS-dark-blue)",
      "color-bg-base-secondary": "var(--Legalstart_LS-white)",
      "color-bg-base-secondary-active": "var(--Legalstart_LS-white)",
      "color-bg-base-secondary-hover": "var(--Legalstart_LS-white)",
      "color-bg-base-tertiary": "var(--Legalstart_LS-beige)",
      "color-bg-base-tertiary-hover": "var(--Legalstart_LS-beige)",
      "color-bg-base-tertiary-active": "var(--Legalstart_LS-beige)",
      "color-bg-base-normal": "var(--Legalstart_LS-white)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Legalstart_LS-dark-blue)",
      "color-bg-base-disable": "var(--Legalstart_LS-light-grey)",
      "color-bg-base-hover": "var(--Legalstart_LS-white)",
      "color-bg-base-focus": "var(--Legalstart_LS-white)",
      "color-bg-base-active-disable": "var(--Legalstart_LS-light-grey)",
      "color-bg-base-inverse": "var(--Legalstart_LS-dark-green)",
      "color-bg-base-highlight": "#03323080",
      "color-bg-danger-primary": "var(--Legacy-Red-600)",
      "color-bg-danger-primary-hover": "var(--Legacy-Red-700)",
      "color-bg-danger-primary-active": "var(--Legacy-Red-800)",
      "color-bg-danger-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-danger-inverse": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary": "var(--Legalstart_LS-white)",
      "color-bg-danger-secondary-hover": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary-active": "var(--Legacy-Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Legacy-Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Legacy-Red-200)",
      "color-bg-danger-tertiary-active": "var(--Legacy-Red-300)",
      "color-bg-warning-primary": "var(--Legacy-Orange-600)",
      "color-bg-warning-primary-hover": "var(--Legacy-Orange-700)",
      "color-bg-warning-primary-active": "var(--Legacy-Orange-800)",
      "color-bg-warning-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-warning-inverse": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary": "var(--Legalstart_LS-white)",
      "color-bg-warning-secondary-hover": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary-active": "var(--Legacy-Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Legacy-Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Legacy-Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Legacy-Orange-300)",
      "color-bg-success-primary": "var(--Legacy-Green-600)",
      "color-bg-success-primary-hover": "var(--Legacy-Green-700)",
      "color-bg-success-primary-active": "var(--Legacy-Green-800)",
      "color-bg-success-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-success-inverse": "var(--Legacy-Green-100)",
      "color-bg-success-secondary": "var(--Legalstart_LS-white)",
      "color-bg-success-secondary-hover": "var(--Legacy-Green-100)",
      "color-bg-success-secondary-active": "var(--Legacy-Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Legacy-Green-100)",
      "color-bg-success-tertiary-hover": "var(--Legacy-Green-200)",
      "color-bg-success-tertiary-active": "var(--Legacy-Green-300)",
      "color-bg-info-inverse": "var(--Legacy-Blue-200)",
      "color-bg-info-primary": "var(--Legacy-Blue-600)",
      "color-bg-info-primary-hover": "var(--Legacy-Blue-700)",
      "color-bg-info-primary-active": "var(--Legacy-Blue-800)",
      "color-bg-info-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-info-secondary": "var(--Legalstart_LS-white)",
      "color-bg-info-secondary-hover": "var(--Legacy-Blue-100)",
      "color-bg-info-secondary-active": "var(--Legacy-Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Legacy-Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Legacy-Blue-200)",
      "color-bg-info-tertiary-active": "var(--Legacy-Blue-300)",
      "color-bg-decorative-primary": "var(--Legalstart_LS-dark-blue)",
      "color-bg-decorative-primary-hover": "var(--Legalstart_LS-dark-blue)",
      "color-bg-decorative-primary-active": "var(--Legalstart_LS-dark-blue)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#00000000",
      "color-bg-decorative-active": "#00000000",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Legalstart_LS-light-yellow)",
      "color-bg-decorative-2": "var(--Legalstart_LS-light-yellow)",
      "color-bg-decorative-3": "var(--Legalstart_LS-light-yellow)",
      "color-bg-decorative-4": "var(--Legalstart_LS-light-yellow)",
      "color-bg-decorative-5": "var(--Legalstart_LS-light-yellow)",
      "color-bg-neutral": "var(--Legalstart_LS-dark-green)",
      "color-bg-neutral-inverse": "var(--Legalstart_LS-beige)",
      "color-bg-brand-light": "var(--Legalstart_LS-light-yellow)",
      "color-bg-brand": "var(--Legalstart_LS-light-yellow)",
      "color-bg-brand-dark": "var(--Legalstart_LS-light-yellow)",
      "color-fg-base-primary": "var(--Legalstart_LS-white)",
      "color-fg-base-secondary": "var(--Legalstart_LS-dark-blue)",
      "color-fg-base-tertiary": "var(--Legalstart_LS-dark-green)",
      "color-fg-base-active": "var(--Legalstart_LS-white)",
      "color-fg-base-disable": "#A6A6A6",
      "color-fg-base": "var(--Legalstart_LS-dark-green)",
      "color-fg-base-focus": "var(--Legalstart_LS-dark-green)",
      "color-fg-base-inverse": "var(--Legalstart_LS-white)",
      "color-fg-base-active-inverse": "var(--Legalstart_LS-dark-green)",
      "color-fg-danger-primary": "var(--Legalstart_LS-white)",
      "color-fg-danger": "var(--Legacy-Red-600)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Legalstart_LS-white)",
      "color-fg-success": "var(--Legacy-Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Legalstart_LS-white)",
      "color-fg-warning": "var(--Legacy-Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Legalstart_LS-white)",
      "color-fg-info": "var(--Legacy-Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Legalstart_LS-dark-green)",
      "color-fg-decorative-disable": "#00000040",
      "color-stroke-base-input": "var(--Legalstart_LS-dark-beige)",
      "color-stroke-base-input-hover": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-input-active": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-input-disable": "var(--Legalstart_LS-light-grey)",
      "color-stroke-base-main-selected": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-input-focus": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-main-highlight": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-basic": "var(--Legalstart_LS-dark-beige)",
      "color-stroke-base-main": "var(--Legalstart_LS-dark-beige)",
      "color-stroke-base-main-hover": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-main-active": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-main-disable": "var(--Legalstart_LS-light-grey)",
      "color-stroke-base-input-selected": "var(--Legalstart_LS-dark-green)",
      "color-stroke-base-input-highlight": "var(--Legalstart_LS-dark-green)",
      "color-stroke-danger": "var(--Legacy-Red-600)",
      "color-stroke-danger-hover": "var(--Legacy-Red-700)",
      "color-stroke-danger-active": "var(--Legacy-Red-800)",
      "color-stroke-success": "var(--Legacy-Green-600)",
      "color-stroke-success-hover": "var(--Legacy-Green-700)",
      "color-stroke-success-active": "var(--Legacy-Green-800)",
      "color-stroke-warning": "var(--Legacy-Orange-600)",
      "color-stroke-warning-hover": "var(--Legacy-Orange-700)",
      "color-stroke-warning-active": "var(--Legacy-Orange-800)",
      "color-stroke-info": "var(--Legacy-Blue-600)",
      "color-stroke-info-hover": "var(--Legacy-Blue-700)",
      "color-stroke-info-active": "var(--Legacy-Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Legalstart_LS-dark-green)",
      "color-text-base-primary": "var(--Legalstart_LS-white)",
      "color-text-base-secondary": "var(--Legalstart_LS-dark-blue)",
      "color-text-base-main": "var(--Legalstart_LS-dark-green)",
      "color-text-base-basic": "var(--Legalstart_LS-grey)",
      "color-text-base-disable": "#A6A6A6",
      "color-text-base-link": "var(--Legalstart_LS-blue)",
      "color-text-base-inverse": "var(--Legalstart_LS-white)",
      "color-text-danger-primary": "var(--Legacy-Red-800)",
      "color-text-danger-secondary": "var(--Legacy-Red-600)",
      "color-text-success-primary": "var(--Legacy-Green-800)",
      "color-text-success-secondary": "var(--Legacy-Green-600)",
      "color-text-warning-primary": "var(--Legacy-Orange-800)",
      "color-text-warning-secondary": "var(--Legacy-Orange-600)",
      "color-text-info-primary": "var(--Legacy-Blue-800)",
      "color-text-info-secondary": "var(--Legacy-Blue-600)",
      "color-text-decorative-secondary": "var(--Legalstart_LS-dark-green)",
      "color-text-decorative-tertiary": "var(--Legalstart_LS-dark-green)",
      "color-text-decorative-disable": "var(--Legalstart_LS-light-grey)",
      "color-text-decorative-main": "var(--Legalstart_LS-dark-green)",
      "color-text-decorative-basic": "var(--Legalstart_LS-grey)",
      "color-text-decorative-primary": "var(--Legalstart_LS-white)",
      "color-text-decorative-1": "var(--Legalstart_LS-yellow)",
      "color-text-decorative-2": "var(--Legalstart_LS-yellow)",
      "color-text-decorative-3": "var(--Legalstart_LS-yellow)",
      "color-text-decorative-4": "var(--Legalstart_LS-yellow)",
      "color-text-decorative-5": "var(--Legalstart_LS-yellow)"
    },
    "light": {
      "color-background": "var(--White)",
      "color-bg-base-primary": "var(--Gray800)",
      "color-bg-base-primary-hover": "var(--Gray700)",
      "color-bg-base-primary-active": "var(--Gray700)",
      "color-bg-base-secondary": "var(--White)",
      "color-bg-base-secondary-active": "var(--Gray100)",
      "color-bg-base-secondary-hover": "var(--Gray100)",
      "color-bg-base-tertiary": "var(--Gray200)",
      "color-bg-base-tertiary-hover": "var(--Gray200)",
      "color-bg-base-tertiary-active": "var(--Gray300)",
      "color-bg-base-normal": "var(--White)",
      "color-bg-base-normal-subtle": "var(--Gray50)",
      "color-bg-base-active": "var(--Periwinkle-dark)",
      "color-bg-base-disable": "var(--Gray200)",
      "color-bg-base-hover": "var(--Gray100)",
      "color-bg-base-focus": "var(--Gray100)",
      "color-bg-base-active-disable": "var(--Gray300)",
      "color-bg-base-inverse": "var(--Gray800)",
      "color-bg-base-highlight": "#755de980",
      "color-bg-danger-primary": "var(--Red-500)",
      "color-bg-danger-primary-hover": "var(--Red-600)",
      "color-bg-danger-primary-active": "var(--Red-600)",
      "color-bg-danger-primary-disable": "var(--Gray100)",
      "color-bg-danger-inverse": "var(--Red-200)",
      "color-bg-danger-secondary": "var(--White)",
      "color-bg-danger-secondary-hover": "var(--Red-100)",
      "color-bg-danger-secondary-active": "var(--Red-100)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Red-200)",
      "color-bg-danger-tertiary-active": "var(--Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--White)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-100)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--White)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Gray100)",
      "color-bg-info-secondary": "var(--White)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--Gray800)",
      "color-bg-decorative-primary-hover": "var(--Gray700)",
      "color-bg-decorative-primary-active": "var(--Gray700)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "var(--White)",
      "color-bg-decorative-hover": "#0000000d",
      "color-bg-decorative-active": "#0000001a",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Periwinkle)",
      "color-bg-decorative-2": "var(--Sky)",
      "color-bg-decorative-3": "var(--Mindaro)",
      "color-bg-decorative-4": "var(--Jasmine)",
      "color-bg-decorative-5": "var(--Peach)",
      "color-bg-neutral": "var(--Gray800)",
      "color-bg-neutral-inverse": "var(--Gray200)",
      "color-bg-brand-light": "var(--Periwinkle-light)",
      "color-bg-brand": "var(--Periwinkle)",
      "color-bg-brand-dark": "var(--Periwinkle-dark)",
      "color-fg-base-primary": "var(--White)",
      "color-fg-base-secondary": "var(--Gray800)",
      "color-fg-base-tertiary": "var(--Gray800)",
      "color-fg-base-active": "var(--White)",
      "color-fg-base-disable": "var(--Gray400)",
      "color-fg-base": "var(--Gray800)",
      "color-fg-base-focus": "var(--Gray800)",
      "color-fg-base-inverse": "var(--White)",
      "color-fg-base-active-inverse": "var(--Gray800)",
      "color-fg-danger-primary": "var(--White)",
      "color-fg-danger": "var(--Red-500)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--White)",
      "color-fg-warning": "var(--Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Gray800)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--White)",
      "color-fg-decorative-secondary": "var(--Gray800)",
      "color-fg-decorative-tertiary": "var(--Gray800)",
      "color-stroke-base-input": "var(--Gray400)",
      "color-stroke-base-input-hover": "var(--Gray500)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Periwinkle-dark)",
      "color-stroke-base-input-focus": "var(--Gray800)",
      "color-stroke-base-main-highlight": "#755de940",
      "color-stroke-base-basic": "var(--Gray300)",
      "color-stroke-base-main": "var(--Gray300)",
      "color-stroke-base-main-hover": "var(--Gray400)",
      "color-stroke-base-main-active": "var(--Gray500)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Periwinkle-dark)",
      "color-stroke-base-input-highlight": "#755de940",
      "color-stroke-danger": "var(--Red-500)",
      "color-stroke-danger-hover": "var(--Red-600)",
      "color-stroke-danger-active": "var(--Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Gray800)",
      "color-text-base-primary": "var(--White)",
      "color-text-base-secondary": "var(--Gray800)",
      "color-text-base-main": "var(--Gray800)",
      "color-text-base-basic": "var(--Gray700)",
      "color-text-base-disable": "var(--Gray500)",
      "color-text-base-link": "var(--Periwinkle-dark)",
      "color-text-base-inverse": "var(--White)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Red-500)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--Gray800)",
      "color-text-decorative-tertiary": "var(--Gray800)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Gray800)",
      "color-text-decorative-basic": "var(--Gray700)",
      "color-text-decorative-primary": "var(--White)",
      "color-text-decorative-1": "var(--Periwinkle)",
      "color-text-decorative-2": "var(--Sky)",
      "color-text-decorative-3": "var(--Mindaro)",
      "color-text-decorative-4": "var(--Jasmine)",
      "color-text-decorative-5": "var(--Peach)"
    },
    "obat": {
      "color-background": "var(--Obat_White)",
      "color-bg-base-primary": "var(--Obat_Blue-02)",
      "color-bg-base-primary-hover": "var(--Obat_Blue-01)",
      "color-bg-base-primary-active": "var(--Obat_Blue-00)",
      "color-bg-base-secondary": "var(--Obat_White)",
      "color-bg-base-secondary-active": "var(--Obat_Grey-09)",
      "color-bg-base-secondary-hover": "var(--Obat_Grey-15)",
      "color-bg-base-tertiary": "var(--Obat_Grey-15)",
      "color-bg-base-tertiary-hover": "var(--Obat_Grey-09)",
      "color-bg-base-tertiary-active": "var(--Obat_Grey-09)",
      "color-bg-base-normal": "var(--Obat_White)",
      "color-bg-base-active": "var(--Obat_Blue-02)",
      "color-bg-base-disable": "var(--Obat_Grey-09)",
      "color-bg-base-hover": "var(--Obat_Grey-15)",
      "color-bg-base-focus": "var(--Obat_Grey-15)",
      "color-bg-base-active-disable": "var(--Obat_Grey-07)",
      "color-bg-base-inverse": "var(--Obat_Grey-00)",
      "color-bg-base-highlight": "var(--Obat_Blue-02)",
      "color-bg-base-normal-subtle": "var(--Obat_White)",
      "color-bg-danger-primary": "var(--Obat_Red-02)",
      "color-bg-danger-primary-hover": "var(--Obat_Red-01)",
      "color-bg-danger-primary-active": "var(--Obat_Red-01)",
      "color-bg-danger-primary-disable": "var(--Obat_Grey-03)",
      "color-bg-danger-inverse": "var(--Obat_Red-09)",
      "color-bg-danger-secondary": "var(--Obat_White)",
      "color-bg-danger-secondary-hover": "var(--Obat_Red-09)",
      "color-bg-danger-secondary-active": "var(--Obat_Red-09)",
      "color-bg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-danger-tertiary": "var(--Obat_Red-09)",
      "color-bg-danger-tertiary-hover": "var(--Obat_Red-09)",
      "color-bg-danger-tertiary-active": "var(--Obat_Red-09)",
      "color-bg-warning-primary": "var(--Obat_Amber-02)",
      "color-bg-warning-primary-hover": "var(--Obat_Amber-01)",
      "color-bg-warning-primary-active": "var(--Obat_Amber-01)",
      "color-bg-warning-primary-disable": "var(--Obat_Grey-03)",
      "color-bg-warning-inverse": "var(--Obat_Amber-09)",
      "color-bg-warning-secondary": "var(--Obat_White)",
      "color-bg-warning-secondary-hover": "var(--Obat_Amber-09)",
      "color-bg-warning-secondary-active": "var(--Obat_Amber-09)",
      "color-bg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-warning-tertiary": "var(--Obat_Amber-09)",
      "color-bg-warning-tertiary-hover": "var(--Obat_Amber-09)",
      "color-bg-warning-tertiary-active": "var(--Obat_Amber-09)",
      "color-bg-success-primary": "var(--Obat_Green-02)",
      "color-bg-success-primary-hover": "var(--Obat_Green-01)",
      "color-bg-success-primary-active": "var(--Obat_Green-01)",
      "color-bg-success-primary-disable": "var(--Obat_Grey-03)",
      "color-bg-success-inverse": "var(--Obat_Green-09)",
      "color-bg-success-secondary": "var(--Obat_White)",
      "color-bg-success-secondary-hover": "var(--Obat_Green-09)",
      "color-bg-success-secondary-active": "var(--Obat_Green-09)",
      "color-bg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-success-tertiary": "var(--Obat_Green-09)",
      "color-bg-success-tertiary-hover": "var(--Obat_Green-09)",
      "color-bg-success-tertiary-active": "var(--Obat_Green-09)",
      "color-bg-info-inverse": "var(--Obat_Blue-09)",
      "color-bg-info-primary": "var(--Obat_Blue-02)",
      "color-bg-info-primary-hover": "var(--Obat_Blue-01)",
      "color-bg-info-primary-active": "var(--Obat_Blue-01)",
      "color-bg-info-primary-disable": "var(--Obat_Grey-03)",
      "color-bg-info-secondary": "var(--Obat_White)",
      "color-bg-info-secondary-hover": "var(--Obat_Blue-09)",
      "color-bg-info-secondary-active": "var(--Obat_Blue-09)",
      "color-bg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-info-tertiary": "var(--Obat_Blue-09)",
      "color-bg-info-tertiary-hover": "var(--Obat_Blue-09)",
      "color-bg-info-tertiary-active": "var(--Obat_Blue-09)",
      "color-bg-decorative-primary": "var(--Obat_White)",
      "color-bg-decorative-primary-hover": "var(--Obat_Grey-09)",
      "color-bg-decorative-primary-active": "var(--Obat_Grey-09)",
      "color-bg-decorative-disable": "rgb(0 0 0 / 0)",
      "color-bg-decorative-secondary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-hover": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-active": "rgb(0 0 0 / 0.1)",
      "color-bg-decorative-tertiary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-1": "var(--Obat_Blue-02)",
      "color-bg-decorative-2": "var(--Obat_Blue-02)",
      "color-bg-decorative-3": "var(--Obat_Blue-02)",
      "color-bg-decorative-4": "var(--Obat_Blue-02)",
      "color-bg-decorative-5": "var(--Obat_Blue-02)",
      "color-bg-neutral": "var(--Obat_Grey-01)",
      "color-bg-neutral-inverse": "var(--Obat_Grey-15)",
      "color-bg-brand-light": "var(--Obat_Blue-03)",
      "color-bg-brand": "var(--Obat_Blue-primary)",
      "color-bg-brand-dark": "var(--Obat_Green-02)",
      "color-fg-base-primary": "var(--Obat_White)",
      "color-fg-base-secondary": "var(--Obat_Grey-01)",
      "color-fg-base-tertiary": "var(--Obat_Grey-01)",
      "color-fg-base-active": "var(--Obat_White)",
      "color-fg-base-disable": "var(--Obat_Grey-03)",
      "color-fg-base": "var(--Obat_Grey-01)",
      "color-fg-base-focus": "var(--Obat_Grey-01)",
      "color-fg-base-inverse": "var(--Obat_White)",
      "color-fg-base-active-inverse": "var(--Obat_Grey-01)",
      "color-fg-danger-primary": "var(--Obat_White)",
      "color-fg-danger": "var(--Obat_Red-01)",
      "color-fg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-danger-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-success-primary": "var(--Obat_White)",
      "color-fg-success": "var(--Obat_Green-01)",
      "color-fg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-success-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-warning-primary": "var(--Obat_White)",
      "color-fg-warning": "var(--Obat_Amber-01)",
      "color-fg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-warning-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-info-primary": "var(--Obat_White)",
      "color-fg-info": "var(--Obat_Blue-01)",
      "color-fg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-info-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative": "var(--Obat_White)",
      "color-fg-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative-primary": "var(--Obat_Grey-01)",
      "color-fg-decorative-secondary": "var(--Obat_White)",
      "color-fg-decorative-tertiary": "var(--Obat_White)",
      "color-stroke-base-input": "var(--Obat_Grey-03)",
      "color-stroke-base-input-hover": "var(--Obat_Grey-03)",
      "color-stroke-base-input-active": "var(--Obat_Grey-03)",
      "color-stroke-base-input-disable": "var(--Obat_Grey-03)",
      "color-stroke-base-main-selected": "var(--Obat_Blue-02)",
      "color-stroke-base-input-focus": "var(--Obat_Grey-02)",
      "color-stroke-base-main-highlight": "var(--Obat_Blue-02)",
      "color-stroke-base-basic": "var(--Obat_Grey-09)",
      "color-stroke-base-main": "var(--Obat_Grey-03)",
      "color-stroke-base-main-hover": "var(--Obat_Grey-03)",
      "color-stroke-base-main-active": "var(--Obat_Grey-02)",
      "color-stroke-base-main-disable": "var(--Obat_Grey-03)",
      "color-stroke-base-input-selected": "var(--Obat_Blue-02)",
      "color-stroke-base-input-highlight": "var(--Obat_Blue-02)",
      "color-stroke-danger": "var(--Obat_Red-02)",
      "color-stroke-danger-hover": "var(--Obat_Red-02)",
      "color-stroke-danger-active": "var(--Obat_Red-02)",
      "color-stroke-success": "var(--Obat_Green-02)",
      "color-stroke-success-hover": "var(--Obat_Green-02)",
      "color-stroke-success-active": "var(--Obat_Green-02)",
      "color-stroke-warning": "var(--Obat_Amber-02)",
      "color-stroke-warning-hover": "var(--Obat_Amber-02)",
      "color-stroke-warning-active": "var(--Obat_Amber-02)",
      "color-stroke-info": "var(--Obat_Blue-02)",
      "color-stroke-info-hover": "var(--Obat_Blue-02)",
      "color-stroke-info-active": "var(--Obat_Blue-02)",
      "color-stroke-decorative": "rgb(0 0 0 / 0.15)",
      "color-stroke-decorative-hover": "rgb(0 0 0 / 0.25)",
      "color-stroke-decorative-active": "rgb(0 0 0 / 0.5)",
      "color-stroke-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-base-tertiary": "var(--Obat_Grey-01)",
      "color-text-base-primary": "var(--Obat_White)",
      "color-text-base-secondary": "var(--Obat_Grey-01)",
      "color-text-base-main": "var(--Obat_Grey-01)",
      "color-text-base-basic": "var(--Obat_Grey-02)",
      "color-text-base-disable": "var(--Obat_Grey-03)",
      "color-text-base-link": "var(--Obat_Blue-02)",
      "color-text-base-inverse": "var(--Obat_White)",
      "color-text-danger-primary": "var(--Obat_Grey-01)",
      "color-text-danger-secondary": "var(--Obat_Grey-02)",
      "color-text-success-primary": "var(--Obat_Grey-01)",
      "color-text-success-secondary": "var(--Obat_Grey-02)",
      "color-text-warning-primary": "var(--Obat_Grey-01)",
      "color-text-warning-secondary": "var(--Obat_Grey-02)",
      "color-text-info-primary": "var(--Obat_Grey-01)",
      "color-text-info-secondary": "var(--Obat_Grey-02)",
      "color-text-decorative-secondary": "var(--Obat_White)",
      "color-text-decorative-tertiary": "var(--Obat_White)",
      "color-text-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-decorative-main": "var(--Obat_White)",
      "color-text-decorative-basic": "var(--Obat_Grey-09)",
      "color-text-decorative-primary": "var(--Obat_Grey-01)",
      "color-text-decorative-1": "var(--Obat_Blue-06)",
      "color-text-decorative-2": "var(--Obat_Blue-06)",
      "color-text-decorative-3": "var(--Obat_Blue-06)",
      "color-text-decorative-4": "var(--Obat_Blue-06)",
      "color-text-decorative-5": "var(--Obat_Blue-06)",
      "color-background-subtle": "var(--Obat_Grey-15)"
    },
    "phenix": {
      "color-background": "var(--Phenix_White)",
      "color-bg-base-primary": "var(--Phenix_Blue)",
      "color-bg-base-primary-hover": "var(--Phenix_Blue)",
      "color-bg-base-primary-active": "var(--Phenix_Blue)",
      "color-bg-base-secondary": "var(--Phenix_White)",
      "color-bg-base-secondary-active": "var(--Phenix_White)",
      "color-bg-base-secondary-hover": "var(--Phenix_White)",
      "color-bg-base-tertiary": "var(--Gray200)",
      "color-bg-base-tertiary-hover": "var(--Gray300)",
      "color-bg-base-tertiary-active": "var(--Gray300)",
      "color-bg-base-normal": "var(--Phenix_White)",
      "color-bg-base-active": "var(--Phenix_Blue)",
      "color-bg-base-disable": "var(--Gray200)",
      "color-bg-base-hover": "var(--Phenix_Gray)",
      "color-bg-base-focus": "var(--Phenix_Gray)",
      "color-bg-base-active-disable": "var(--Gray300)",
      "color-bg-base-inverse": "var(--Phenix_Black)",
      "color-bg-base-highlight": "var(--Phenix_Blue)",
      "color-bg-base-normal-subtle": "var(--Phenix_White)",
      "color-bg-danger-primary": "var(--Red-500)",
      "color-bg-danger-primary-hover": "var(--Red-600)",
      "color-bg-danger-primary-active": "var(--Red-600)",
      "color-bg-danger-primary-disable": "var(--Gray100)",
      "color-bg-danger-inverse": "var(--Red-200)",
      "color-bg-danger-secondary": "var(--Phenix_White)",
      "color-bg-danger-secondary-hover": "var(--Red-100)",
      "color-bg-danger-secondary-active": "var(--Red-100)",
      "color-bg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-danger-tertiary": "var(--Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Red-200)",
      "color-bg-danger-tertiary-active": "var(--Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--Phenix_White)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-100)",
      "color-bg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--White)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Gray100)",
      "color-bg-info-secondary": "var(--Phenix_White)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--Phenix_Blue)",
      "color-bg-decorative-primary-hover": "var(--Phenix_Blue)",
      "color-bg-decorative-primary-active": "var(--Phenix_Blue)",
      "color-bg-decorative-disable": "rgb(0 0 0 / 0)",
      "color-bg-decorative-secondary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-hover": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-active": "rgb(0 0 0 / 0.1)",
      "color-bg-decorative-tertiary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-1": "var(--Phenix_Gray)",
      "color-bg-decorative-2": "var(--Phenix_Gray)",
      "color-bg-decorative-3": "var(--Phenix_Gray)",
      "color-bg-decorative-4": "var(--Phenix_Gray)",
      "color-bg-decorative-5": "var(--Phenix_Gray)",
      "color-bg-neutral": "var(--Phenix_Black)",
      "color-bg-neutral-inverse": "var(--Gray200)",
      "color-bg-brand-light": "var(--Phenix_Gray)",
      "color-bg-brand": "var(--Phenix_Gray)",
      "color-bg-brand-dark": "var(--Phenix_Gray)",
      "color-fg-base-primary": "var(--Phenix_White)",
      "color-fg-base-secondary": "var(--Phenix_Black)",
      "color-fg-base-tertiary": "var(--Phenix_Black)",
      "color-fg-base-active": "var(--Phenix_White)",
      "color-fg-base-disable": "var(--Gray400)",
      "color-fg-base": "var(--Phenix_Black)",
      "color-fg-base-focus": "var(--Phenix_Black)",
      "color-fg-base-inverse": "var(--Phenix_White)",
      "color-fg-base-active-inverse": "var(--Phenix_Black)",
      "color-fg-danger-primary": "var(--Phenix_White)",
      "color-fg-danger": "var(--Red-500)",
      "color-fg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-danger-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-success-primary": "var(--Phenix_White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-success-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-warning-primary": "var(--Phenix_White)",
      "color-fg-warning": "var(--Orange-500)",
      "color-fg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-warning-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-info-primary": "var(--Phenix_White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-info-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative": "var(--Phenix_Black)",
      "color-fg-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative-primary": "var(--Phenix_White)",
      "color-fg-decorative-secondary": "var(--Phenix_Black)",
      "color-fg-decorative-tertiary": "var(--Phenix_Black)",
      "color-stroke-base-input": "var(--Gray300)",
      "color-stroke-base-input-hover": "var(--Gray400)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Gray500)",
      "color-stroke-base-input-focus": "var(--Phenix_Black)",
      "color-stroke-base-main-highlight": "var(--Phenix_Blue)",
      "color-stroke-base-basic": "var(--Gray200)",
      "color-stroke-base-main": "var(--Gray300)",
      "color-stroke-base-main-hover": "var(--Gray300)",
      "color-stroke-base-main-active": "var(--Gray300)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Phenix_Blue)",
      "color-stroke-base-input-highlight": "var(--Phenix_Blue)",
      "color-stroke-danger": "var(--Red-500)",
      "color-stroke-danger-hover": "var(--Red-600)",
      "color-stroke-danger-active": "var(--Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "rgb(0 0 0 / 0.15)",
      "color-stroke-decorative-hover": "rgb(0 0 0 / 0.25)",
      "color-stroke-decorative-active": "rgb(0 0 0 / 0.5)",
      "color-stroke-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-base-tertiary": "var(--Phenix_Black)",
      "color-text-base-primary": "var(--Phenix_White)",
      "color-text-base-secondary": "var(--Phenix_Black)",
      "color-text-base-main": "var(--Phenix_Black)",
      "color-text-base-basic": "var(--Gray700)",
      "color-text-base-disable": "var(--Gray400)",
      "color-text-base-link": "var(--Phenix_Blue)",
      "color-text-base-inverse": "var(--Phenix_White)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Red-500)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--Phenix_Black)",
      "color-text-decorative-tertiary": "var(--Phenix_Black)",
      "color-text-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-decorative-main": "var(--Phenix_Black)",
      "color-text-decorative-basic": "var(--Phenix_Blue)",
      "color-text-decorative-primary": "var(--Phenix_White)",
      "color-text-decorative-1": "var(--Phenix_Gray)",
      "color-text-decorative-2": "var(--Phenix_Gray)",
      "color-text-decorative-3": "var(--Phenix_Gray)",
      "color-text-decorative-4": "var(--Phenix_Gray)",
      "color-text-decorative-5": "var(--Phenix_Gray)",
      "color-background-subtle": "var(--Phenix_Gray)"
    },
    "previi": {
      "color-background": "var(--Previi_Gray-light)",
      "color-bg-base-primary": "var(--Previi_Red)",
      "color-bg-base-primary-hover": "var(--Previi_Red)",
      "color-bg-base-primary-active": "var(--Previi_Red)",
      "color-bg-base-secondary": "var(--Legacy-White)",
      "color-bg-base-secondary-active": "var(--Legacy-White)",
      "color-bg-base-secondary-hover": "var(--Legacy-White)",
      "color-bg-base-tertiary": "var(--Previi_Gray)",
      "color-bg-base-tertiary-hover": "var(--Previi_Gray)",
      "color-bg-base-tertiary-active": "var(--Previi_Gray)",
      "color-bg-base-normal": "var(--Legacy-White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Previi_Red)",
      "color-bg-base-disable": "var(--Legacy-Gray-200)",
      "color-bg-base-hover": "var(--Legacy-Blue-100)",
      "color-bg-base-focus": "var(--Legacy-Blue-100)",
      "color-bg-base-active-disable": "var(--Legacy-Gray-300)",
      "color-bg-base-inverse": "var(--Legacy-Black)",
      "color-bg-base-highlight": "#FE5F6980",
      "color-bg-danger-primary": "var(--Legacy-Red-600)",
      "color-bg-danger-primary-hover": "var(--Legacy-Red-700)",
      "color-bg-danger-primary-active": "var(--Legacy-Red-800)",
      "color-bg-danger-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-danger-inverse": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary": "var(--Legacy-White)",
      "color-bg-danger-secondary-hover": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary-active": "var(--Legacy-Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Legacy-Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Legacy-Red-200)",
      "color-bg-danger-tertiary-active": "var(--Legacy-Red-300)",
      "color-bg-warning-primary": "var(--Legacy-Orange-600)",
      "color-bg-warning-primary-hover": "var(--Legacy-Orange-700)",
      "color-bg-warning-primary-active": "var(--Legacy-Orange-800)",
      "color-bg-warning-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-warning-inverse": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary": "var(--Legacy-White)",
      "color-bg-warning-secondary-hover": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary-active": "var(--Legacy-Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Legacy-Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Legacy-Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Legacy-Orange-300)",
      "color-bg-success-primary": "var(--Legacy-Green-600)",
      "color-bg-success-primary-hover": "var(--Legacy-Green-700)",
      "color-bg-success-primary-active": "var(--Legacy-Green-800)",
      "color-bg-success-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-success-inverse": "var(--Legacy-Green-100)",
      "color-bg-success-secondary": "var(--Legacy-White)",
      "color-bg-success-secondary-hover": "var(--Legacy-Green-100)",
      "color-bg-success-secondary-active": "var(--Legacy-Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Legacy-Green-100)",
      "color-bg-success-tertiary-hover": "var(--Legacy-Green-200)",
      "color-bg-success-tertiary-active": "var(--Legacy-Green-300)",
      "color-bg-info-inverse": "var(--Legacy-Blue-200)",
      "color-bg-info-primary": "var(--Legacy-Blue-600)",
      "color-bg-info-primary-hover": "var(--Legacy-Blue-700)",
      "color-bg-info-primary-active": "var(--Legacy-Blue-800)",
      "color-bg-info-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-info-secondary": "var(--Legacy-White)",
      "color-bg-info-secondary-hover": "var(--Legacy-Blue-100)",
      "color-bg-info-secondary-active": "var(--Legacy-Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Legacy-Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Legacy-Blue-200)",
      "color-bg-info-tertiary-active": "var(--Legacy-Blue-300)",
      "color-bg-decorative-primary": "var(--Previi_Red)",
      "color-bg-decorative-primary-hover": "var(--Previi_Red)",
      "color-bg-decorative-primary-active": "var(--Previi_Red)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000D",
      "color-bg-decorative-active": "#0000001A",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Previi_Blue-dark)",
      "color-bg-decorative-2": "var(--Previi_Blue-dark)",
      "color-bg-decorative-3": "var(--Previi_Blue-dark)",
      "color-bg-decorative-4": "var(--Previi_Blue-dark)",
      "color-bg-decorative-5": "var(--Previi_Blue-dark)",
      "color-bg-neutral": "var(--Legacy-Gray-800)",
      "color-bg-neutral-inverse": "var(--Legacy-Gray-100)",
      "color-bg-brand-light": "var(--Previi_Blue-dark)",
      "color-bg-brand": "var(--Previi_Blue-dark)",
      "color-bg-brand-dark": "var(--Previi_Blue-dark)",
      "color-fg-base-primary": "var(--Legacy-White)",
      "color-fg-base-secondary": "var(--Legacy-Black)",
      "color-fg-base-tertiary": "var(--Legacy-White)",
      "color-fg-base-active": "var(--Legacy-White)",
      "color-fg-base-disable": "var(--Legacy-Gray-400)",
      "color-fg-base": "var(--Legacy-Black)",
      "color-fg-base-focus": "var(--Legacy-Black)",
      "color-fg-base-inverse": "var(--Legacy-White)",
      "color-fg-base-active-inverse": "var(--Previi_Red)",
      "color-fg-danger-primary": "var(--Legacy-White)",
      "color-fg-danger": "var(--Legacy-Red-600)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Legacy-White)",
      "color-fg-success": "var(--Legacy-Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Legacy-White)",
      "color-fg-warning": "var(--Legacy-Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Legacy-White)",
      "color-fg-info": "var(--Legacy-Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Legacy-White)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--Legacy-White)",
      "color-fg-decorative-secondary": "var(--Legacy-White)",
      "color-fg-decorative-tertiary": "var(--Legacy-White)",
      "color-stroke-base-input": "var(--Gray400)",
      "color-stroke-base-input-hover": "var(--Gray500)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Previi_Red)",
      "color-stroke-base-input-focus": "var(--Gray800)",
      "color-stroke-base-main-highlight": "var(--Previi_Red)",
      "color-stroke-base-basic": "var(--Gray300)",
      "color-stroke-base-main": "var(--Gray300)",
      "color-stroke-base-main-hover": "var(--Gray400)",
      "color-stroke-base-main-active": "var(--Gray500)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Previi_Red)",
      "color-stroke-base-input-highlight": "var(--Previi_Red)",
      "color-stroke-danger": "var(--Legacy-Red-600)",
      "color-stroke-danger-hover": "var(--Legacy-Red-700)",
      "color-stroke-danger-active": "var(--Legacy-Red-800)",
      "color-stroke-success": "var(--Legacy-Green-600)",
      "color-stroke-success-hover": "var(--Legacy-Green-700)",
      "color-stroke-success-active": "var(--Legacy-Green-800)",
      "color-stroke-warning": "var(--Legacy-Orange-600)",
      "color-stroke-warning-hover": "var(--Legacy-Orange-700)",
      "color-stroke-warning-active": "var(--Legacy-Orange-800)",
      "color-stroke-info": "var(--Legacy-Blue-600)",
      "color-stroke-info-hover": "var(--Legacy-Blue-700)",
      "color-stroke-info-active": "var(--Legacy-Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Legacy-White)",
      "color-text-base-primary": "var(--Legacy-White)",
      "color-text-base-secondary": "var(--Legacy-Black)",
      "color-text-base-main": "var(--Legacy-Black)",
      "color-text-base-basic": "var(--Legacy-Black)",
      "color-text-base-disable": "var(--Legacy-Gray-400)",
      "color-text-base-link": "var(--Previi_Red)",
      "color-text-base-inverse": "var(--Legacy-White)",
      "color-text-danger-primary": "var(--Legacy-Red-800)",
      "color-text-danger-secondary": "var(--Legacy-Red-600)",
      "color-text-success-primary": "var(--Legacy-Green-800)",
      "color-text-success-secondary": "var(--Legacy-Green-600)",
      "color-text-warning-primary": "var(--Legacy-Orange-800)",
      "color-text-warning-secondary": "var(--Legacy-Orange-600)",
      "color-text-info-primary": "var(--Legacy-Blue-800)",
      "color-text-info-secondary": "var(--Legacy-Blue-600)",
      "color-text-decorative-secondary": "var(--Legacy-White)",
      "color-text-decorative-tertiary": "var(--Legacy-White)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Legacy-White)",
      "color-text-decorative-basic": "var(--Legacy-White)",
      "color-text-decorative-primary": "var(--Legacy-White)",
      "color-text-decorative-1": "var(--Legacy-White)",
      "color-text-decorative-2": "var(--Legacy-White)",
      "color-text-decorative-3": "var(--Legacy-White)",
      "color-text-decorative-4": "var(--Legacy-White)",
      "color-text-decorative-5": "var(--Legacy-White)"
    },
    "propulse": {
      "color-background": "var(--Legacy-White)",
      "color-bg-base-primary": "var(--Propulse_Primary-500)",
      "color-bg-base-primary-hover": "var(--Propulse_Primary-500)",
      "color-bg-base-primary-active": "var(--Propulse_Primary-500)",
      "color-bg-base-secondary": "var(--Legacy-White)",
      "color-bg-base-secondary-active": "var(--Legacy-White)",
      "color-bg-base-secondary-hover": "var(--Legacy-White)",
      "color-bg-base-tertiary": "var(--Propulse_Primary-90)",
      "color-bg-base-tertiary-hover": "var(--Propulse_Primary-100)",
      "color-bg-base-tertiary-active": "var(--Propulse_Primary-100)",
      "color-bg-base-normal": "var(--Legacy-White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Propulse_Primary-500)",
      "color-bg-base-disable": "var(--Propulse_Info-100)",
      "color-bg-base-hover": "var(--Propulse_Primary-90)",
      "color-bg-base-focus": "var(--Propulse_Info-90)",
      "color-bg-base-active-disable": "var(--Propulse_Info-100)",
      "color-bg-base-inverse": "var(--Propulse_Info-600)",
      "color-bg-base-highlight": "#00746180",
      "color-bg-danger-primary": "var(--Legacy-Red-600)",
      "color-bg-danger-primary-hover": "var(--Legacy-Red-700)",
      "color-bg-danger-primary-active": "var(--Legacy-Red-800)",
      "color-bg-danger-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-danger-inverse": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary": "var(--Legacy-White)",
      "color-bg-danger-secondary-hover": "var(--Legacy-Red-100)",
      "color-bg-danger-secondary-active": "var(--Legacy-Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Legacy-Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Legacy-Red-200)",
      "color-bg-danger-tertiary-active": "var(--Legacy-Red-300)",
      "color-bg-warning-primary": "var(--Legacy-Orange-600)",
      "color-bg-warning-primary-hover": "var(--Legacy-Orange-700)",
      "color-bg-warning-primary-active": "var(--Legacy-Orange-800)",
      "color-bg-warning-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-warning-inverse": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary": "var(--Legacy-White)",
      "color-bg-warning-secondary-hover": "var(--Legacy-Orange-100)",
      "color-bg-warning-secondary-active": "var(--Legacy-Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Legacy-Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Legacy-Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Legacy-Orange-300)",
      "color-bg-success-primary": "var(--Legacy-Green-600)",
      "color-bg-success-primary-hover": "var(--Legacy-Green-700)",
      "color-bg-success-primary-active": "var(--Legacy-Green-800)",
      "color-bg-success-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-success-inverse": "var(--Legacy-Green-100)",
      "color-bg-success-secondary": "var(--Legacy-White)",
      "color-bg-success-secondary-hover": "var(--Legacy-Green-100)",
      "color-bg-success-secondary-active": "var(--Legacy-Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Legacy-Green-100)",
      "color-bg-success-tertiary-hover": "var(--Legacy-Green-200)",
      "color-bg-success-tertiary-active": "var(--Legacy-Green-300)",
      "color-bg-info-inverse": "var(--Legacy-Blue-200)",
      "color-bg-info-primary": "var(--Legacy-Blue-600)",
      "color-bg-info-primary-hover": "var(--Legacy-Blue-700)",
      "color-bg-info-primary-active": "var(--Legacy-Blue-800)",
      "color-bg-info-primary-disable": "var(--Legacy-Gray-100)",
      "color-bg-info-secondary": "var(--Legacy-White)",
      "color-bg-info-secondary-hover": "var(--Legacy-Blue-100)",
      "color-bg-info-secondary-active": "var(--Legacy-Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Legacy-Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Legacy-Blue-200)",
      "color-bg-info-tertiary-active": "var(--Legacy-Blue-300)",
      "color-bg-decorative-primary": "var(--Legacy-White)",
      "color-bg-decorative-primary-hover": "var(--Propulse_Info-100)",
      "color-bg-decorative-primary-active": "var(--Propulse_Info-100)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000D",
      "color-bg-decorative-active": "#0000001A",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Propulse_Primary-90)",
      "color-bg-decorative-2": "var(--Propulse_Primary-90)",
      "color-bg-decorative-3": "var(--Propulse_Primary-90)",
      "color-bg-decorative-4": "var(--Propulse_Primary-90)",
      "color-bg-decorative-5": "var(--Propulse_Primary-90)",
      "color-bg-neutral": "var(--Propulse_Info-600)",
      "color-bg-neutral-inverse": "var(--Propulse_Info-100)",
      "color-bg-brand-light": "var(--Propulse_Primary-90)",
      "color-bg-brand": "var(--Propulse_Primary-90)",
      "color-bg-brand-dark": "var(--Propulse_Primary-90)",
      "color-fg-base-primary": "var(--Legacy-White)",
      "color-fg-base-secondary": "var(--Propulse_Info-600)",
      "color-fg-base-tertiary": "var(--Propulse_Info-600)",
      "color-fg-base-active": "var(--Propulse_Primary-100)",
      "color-fg-base-disable": "var(--Legacy-Gray-500)",
      "color-fg-base": "var(--Propulse_Info-600)",
      "color-fg-base-focus": "var(--Propulse_Primary-500)",
      "color-fg-base-inverse": "var(--Propulse_Info-90)",
      "color-fg-base-active-inverse": "var(--Propulse_Primary-500)",
      "color-fg-danger-primary": "var(--Legacy-White)",
      "color-fg-danger": "var(--Legacy-Red-600)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Legacy-White)",
      "color-fg-success": "var(--Legacy-Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Legacy-White)",
      "color-fg-warning": "var(--Legacy-Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Legacy-White)",
      "color-fg-info": "var(--Legacy-Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Propulse_Info-600)",
      "color-fg-decorative-disable": "#00000040",
      "color-stroke-base-input": "var(--Propulse_Info-100)",
      "color-stroke-base-input-hover": "var(--Propulse_Info-100)",
      "color-stroke-base-input-active": "var(--Propulse_Primary-500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Propulse_Primary-500)",
      "color-stroke-base-input-focus": "var(--Propulse_Info-600)",
      "color-stroke-base-main-highlight": "var(--Propulse_Primary-500)",
      "color-stroke-base-basic": "var(--Propulse_Info-100)",
      "color-stroke-base-main": "var(--Propulse_Info-100)",
      "color-stroke-base-main-hover": "var(--Propulse_Info-100)",
      "color-stroke-base-main-active": "var(--Propulse_Primary-500)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Propulse_Primary-500)",
      "color-stroke-base-input-highlight": "var(--Propulse_Primary-500)",
      "color-stroke-danger": "var(--Legacy-Red-600)",
      "color-stroke-danger-hover": "var(--Legacy-Red-700)",
      "color-stroke-danger-active": "var(--Legacy-Red-800)",
      "color-stroke-success": "var(--Legacy-Green-600)",
      "color-stroke-success-hover": "var(--Legacy-Green-700)",
      "color-stroke-success-active": "var(--Legacy-Green-800)",
      "color-stroke-warning": "var(--Legacy-Orange-600)",
      "color-stroke-warning-hover": "var(--Legacy-Orange-700)",
      "color-stroke-warning-active": "var(--Legacy-Orange-800)",
      "color-stroke-info": "var(--Legacy-Blue-600)",
      "color-stroke-info-hover": "var(--Legacy-Blue-700)",
      "color-stroke-info-active": "var(--Legacy-Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Legacy-Black)",
      "color-text-base-primary": "var(--Legacy-White)",
      "color-text-base-secondary": "var(--Legacy-Black)",
      "color-text-base-main": "var(--Legacy-Black)",
      "color-text-base-basic": "var(--Propulse_Info-600)",
      "color-text-base-disable": "var(--Legacy-Gray-500)",
      "color-text-base-link": "var(--Propulse_Primary-500)",
      "color-text-danger-primary-inverse": "var(--Legacy-Red-800)",
      "color-text-danger-secondary": "var(--Legacy-Red-600)",
      "color-text-success-primary": "var(--Legacy-Green-800)",
      "color-text-success-secondary": "var(--Legacy-Green-600)",
      "color-text-warning-primary": "var(--Legacy-Orange-800)",
      "color-text-warning-secondary": "var(--Legacy-Orange-600)",
      "color-text-info-primary": "var(--Legacy-Blue-800)",
      "color-text-info-secondary": "var(--Legacy-Blue-600)",
      "color-text-decorative-secondary": "var(--Propulse_Info-600)",
      "color-text-decorative-tertiary": "var(--Propulse_Info-600)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Legacy-Black)",
      "color-text-decorative-basic": "var(--Propulse_Info-600)",
      "color-text-decorative-primary": "var(--Propulse_Info-600)",
      "color-text-decorative-1": "var(--Propulse_Primary-90)",
      "color-text-decorative-2": "var(--Propulse_Primary-90)",
      "color-text-decorative-3": "var(--Propulse_Primary-90)",
      "color-text-decorative-4": "var(--Propulse_Primary-90)",
      "color-text-decorative-5": "var(--Propulse_Primary-90)"
    },
    "qonto": {
      "color-background": "var(--Qonto_White)",
      "color-bg-base-primary": "var(--Qonto_Black)",
      "color-bg-base-primary-hover": "var(--Qonto_Gray700hover)",
      "color-bg-base-primary-active": "var(--Qonto_Gray700hover)",
      "color-bg-base-secondary": "var(--Qonto_White)",
      "color-bg-base-secondary-active": "var(--Qonto_Gray100)",
      "color-bg-base-secondary-hover": "var(--Qonto_Gray100)",
      "color-bg-base-tertiary": "var(--Qonto_Gray200)",
      "color-bg-base-tertiary-hover": "var(--Qonto_Gray300)",
      "color-bg-base-tertiary-active": "var(--Qonto_Gray300)",
      "color-bg-base-normal": "var(--Qonto_White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Qonto_Purple800)",
      "color-bg-base-disable": "var(--Qonto_Gray300)",
      "color-bg-base-hover": "var(--Qonto_Gray100)",
      "color-bg-base-focus": "var(--Qonto_Gray200)",
      "color-bg-base-active-disable": "var(--Qonto_Gray300)",
      "color-bg-base-inverse": "var(--Qonto_Black)",
      "color-bg-base-highlight": "var(--Qonto_Purple500)",
      "color-bg-danger-primary": "var(--Red-600)",
      "color-bg-danger-primary-hover": "var(--Red-600)",
      "color-bg-danger-primary-active": "var(--Red-600)",
      "color-bg-danger-primary-disable": "var(--Qonto_Gray100)",
      "color-bg-danger-inverse": "var(--Red-200)",
      "color-bg-danger-secondary": "var(--Qonto_White)",
      "color-bg-danger-secondary-hover": "var(--Red-100)",
      "color-bg-danger-secondary-active": "var(--Red-100)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Red-100)",
      "color-bg-danger-tertiary-active": "var(--Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Qonto_Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--Qonto_White)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-100)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Qonto_Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--Qonto_White)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Qonto_Gray100)",
      "color-bg-info-secondary": "var(--Qonto_White)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--Qonto_White)",
      "color-bg-decorative-primary-hover": "var(--Qonto_Gray100)",
      "color-bg-decorative-primary-active": "var(--Qonto_Gray100)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000d",
      "color-bg-decorative-active": "#0000001a",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Qonto_Purple500)",
      "color-bg-decorative-2": "var(--Qonto_Mustard800)",
      "color-bg-decorative-3": "var(--Qonto_Mint800)",
      "color-bg-decorative-4": "var(--Qonto_Peach800)",
      "color-bg-decorative-5": "var(--Qonto_Purple500)",
      "color-bg-neutral": "var(--Qonto_Black)",
      "color-bg-neutral-inverse": "var(--Qonto_Gray200)",
      "color-bg-brand-light": "var(--Qonto_Purple200)",
      "color-bg-brand": "var(--Qonto_Purple500)",
      "color-bg-brand-dark": "var(--Qonto_Purple500)",
      "color-fg-base-primary": "var(--Qonto_White)",
      "color-fg-base-secondary": "var(--Qonto_Black)",
      "color-fg-base-tertiary": "var(--Qonto_Black)",
      "color-fg-base-active": "var(--Qonto_White)",
      "color-fg-base-disable": "var(--Qonto_Gray400)",
      "color-fg-base": "var(--Qonto_Black)",
      "color-fg-base-focus": "var(--Qonto_Black)",
      "color-fg-base-inverse": "var(--Qonto_White)",
      "color-fg-base-active-inverse": "var(--Qonto_Black)",
      "color-fg-danger-primary": "var(--Qonto_White)",
      "color-fg-danger": "var(--Red-500)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Qonto_White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Qonto_White)",
      "color-fg-warning": "var(--Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Qonto_White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Qonto_Black)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--Qonto_Black)",
      "color-fg-decorative-secondary": "var(--Qonto_Black)",
      "color-fg-decorative-tertiary": "var(--Qonto_Black)",
      "color-stroke-base-input": "var(--Qonto_Gray400)",
      "color-stroke-base-input-hover": "var(--Qonto_Gray500)",
      "color-stroke-base-input-active": "var(--Qonto_Gray600)",
      "color-stroke-base-input-disable": "var(--Qonto_Gray300)",
      "color-stroke-base-main-selected": "var(--Qonto_Purple500)",
      "color-stroke-base-input-focus": "var(--Qonto_Black)",
      "color-stroke-base-main-highlight": "var(--Qonto_Purple500)",
      "color-stroke-base-basic": "var(--Qonto_Gray400)",
      "color-stroke-base-main": "var(--Qonto_Gray400)",
      "color-stroke-base-main-hover": "var(--Qonto_Gray500)",
      "color-stroke-base-main-active": "var(--Qonto_Gray600)",
      "color-stroke-base-main-disable": "var(--Qonto_Gray300)",
      "color-stroke-base-input-selected": "var(--Qonto_Purple500)",
      "color-stroke-base-input-highlight": "var(--Qonto_Purple500)",
      "color-stroke-danger": "var(--Red-500)",
      "color-stroke-danger-hover": "var(--Red-600)",
      "color-stroke-danger-active": "var(--Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Qonto_Black)",
      "color-text-base-primary": "var(--Qonto_White)",
      "color-text-base-secondary": "var(--Qonto_Black)",
      "color-text-base-main": "var(--Qonto_Black)",
      "color-text-base-basic": "var(--Qonto_Gray700)",
      "color-text-base-disable": "var(--Qonto_Gray500)",
      "color-text-base-link": "var(--Qonto_Purple800)",
      "color-text-base-inverse": "var(--Qonto_White)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Red-500)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--Qonto_Black)",
      "color-text-decorative-tertiary": "var(--Qonto_Black)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Qonto_Black)",
      "color-text-decorative-basic": "var(--Qonto_Gray700)",
      "color-text-decorative-primary": "var(--Qonto_Black)",
      "color-text-decorative-1": "var(--Qonto_Purple500)",
      "color-text-decorative-2": "var(--Qonto_Mustard800)",
      "color-text-decorative-3": "var(--Qonto_Mint800)",
      "color-text-decorative-4": "var(--Qonto_Peach800)",
      "color-text-decorative-5": "var(--Qonto_Purple500)"
    },
    "resco": {
      "color-background": "var(--Resco_White)",
      "color-bg-base-primary": "var(--Resco_Primary)",
      "color-bg-base-primary-hover": "var(--Resco_Primary)",
      "color-bg-base-primary-active": "var(--Resco_Primary)",
      "color-bg-base-secondary": "var(--Resco_White)",
      "color-bg-base-secondary-active": "var(--Resco_White)",
      "color-bg-base-secondary-hover": "var(--Resco_White)",
      "color-bg-base-tertiary": "var(--Gray100)",
      "color-bg-base-tertiary-hover": "var(--Gray100)",
      "color-bg-base-tertiary-active": "var(--Gray100)",
      "color-bg-base-normal": "var(--Resco_White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Resco_Primary)",
      "color-bg-base-disable": "var(--Gray200)",
      "color-bg-base-hover": "var(--Gray100)",
      "color-bg-base-focus": "var(--Gray100)",
      "color-bg-base-active-disable": "var(--Gray300)",
      "color-bg-base-inverse": "var(--Resco_Black)",
      "color-bg-base-highlight": "var(--Resco_Primary)",
      "color-bg-danger-primary": "var(--Resco_Secondary)",
      "color-bg-danger-primary-hover": "var(--Red-600)",
      "color-bg-danger-primary-active": "var(--Red-600)",
      "color-bg-danger-primary-disable": "var(--Resco_Black)",
      "color-bg-danger-inverse": "var(--Red-200)",
      "color-bg-danger-secondary": "var(--Resco_White)",
      "color-bg-danger-secondary-hover": "var(--Red-100)",
      "color-bg-danger-secondary-active": "var(--Red-100)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Red-200)",
      "color-bg-danger-tertiary-active": "var(--Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--Resco_White)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--Resco_White)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Gray100)",
      "color-bg-info-secondary": "var(--Resco_White)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--Resco_Primary)",
      "color-bg-decorative-primary-hover": "var(--Resco_Primary)",
      "color-bg-decorative-primary-active": "var(--Resco_Primary)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000d",
      "color-bg-decorative-active": "#0000001a",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Resco_Background)",
      "color-bg-decorative-2": "var(--Resco_Background)",
      "color-bg-decorative-3": "var(--Resco_Background)",
      "color-bg-decorative-4": "var(--Resco_Background)",
      "color-bg-decorative-5": "var(--Resco_Background)",
      "color-bg-neutral": "var(--Resco_Black)",
      "color-bg-neutral-inverse": "var(--Gray100)",
      "color-bg-brand-light": "var(--Resco_Background)",
      "color-bg-brand": "var(--Resco_Background)",
      "color-bg-brand-dark": "var(--Resco_Background)",
      "color-fg-base-primary": "var(--Resco_White)",
      "color-fg-base-secondary": "var(--Resco_Black)",
      "color-fg-base-tertiary": "var(--Resco_Black)",
      "color-fg-base-active": "var(--Resco_White)",
      "color-fg-base-disable": "var(--Gray400)",
      "color-fg-base": "var(--Resco_Black)",
      "color-fg-base-focus": "var(--Resco_Black)",
      "color-fg-base-inverse": "var(--Resco_White)",
      "color-fg-base-active-inverse": "var(--Resco_Black)",
      "color-fg-danger-primary": "var(--Resco_White)",
      "color-fg-danger": "var(--Resco_Secondary)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Resco_White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Resco_White)",
      "color-fg-warning": "var(--Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Resco_White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Resco_Black)",
      "color-fg-decorative-disable": "#00000040",
      "color-fg-decorative-primary": "var(--Resco_White)",
      "color-fg-decorative-secondary": "var(--Resco_Black)",
      "color-fg-decorative-tertiary": "var(--Resco_Black)",
      "color-stroke-base-input": "var(--Gray400)",
      "color-stroke-base-input-hover": "var(--Gray500)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Resco_Primary)",
      "color-stroke-base-input-focus": "var(--Resco_Black)",
      "color-stroke-base-main-highlight": "var(--Resco_Primary)",
      "color-stroke-base-basic": "var(--Gray300)",
      "color-stroke-base-main": "var(--Gray300)",
      "color-stroke-base-main-hover": "var(--Gray400)",
      "color-stroke-base-main-active": "var(--Gray500)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Resco_Primary)",
      "color-stroke-base-input-highlight": "var(--Resco_Primary)",
      "color-stroke-danger": "var(--Resco_Secondary)",
      "color-stroke-danger-hover": "var(--Red-600)",
      "color-stroke-danger-active": "var(--Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Resco_Black)",
      "color-text-base-primary": "var(--Resco_White)",
      "color-text-base-secondary": "var(--Resco_Black)",
      "color-text-base-main": "var(--Resco_Black)",
      "color-text-base-basic": "var(--Resco_Black)",
      "color-text-base-disable": "var(--Gray500)",
      "color-text-base-link": "var(--Resco_Black)",
      "color-text-base-inverse": "var(--Resco_White)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Resco_Secondary)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--Resco_Black)",
      "color-text-decorative-tertiary": "var(--Resco_Black)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Resco_Black)",
      "color-text-decorative-basic": "var(--Resco_Black)",
      "color-text-decorative-primary": "var(--Resco_White)",
      "color-text-decorative-1": "var(--Resco_White)",
      "color-text-decorative-2": "var(--Resco_White)",
      "color-text-decorative-3": "var(--Resco_White)",
      "color-text-decorative-4": "var(--Resco_White)",
      "color-text-decorative-5": "var(--Resco_White)"
    },
    "revital": {
      "color-background": "var(--White)",
      "color-bg-base-primary": "var(--Revital_Blue-1)",
      "color-bg-base-primary-hover": "var(--Revital_Blue-1)",
      "color-bg-base-primary-active": "var(--Revital_Blue-1)",
      "color-bg-base-secondary": "var(--White)",
      "color-bg-base-secondary-active": "var(--White)",
      "color-bg-base-secondary-hover": "var(--White)",
      "color-bg-base-tertiary": "var(--Revital_Blue-2)",
      "color-bg-base-tertiary-hover": "var(--Revital_Blue-2)",
      "color-bg-base-tertiary-active": "var(--Revital_Blue-2)",
      "color-bg-base-normal": "var(--White)",
      "color-bg-base-active": "var(--Revital_Blue-1)",
      "color-bg-base-disable": "var(--Gray200)",
      "color-bg-base-hover": "var(--Gray100)",
      "color-bg-base-focus": "var(--Gray100)",
      "color-bg-base-active-disable": "var(--Gray200)",
      "color-bg-base-inverse": "var(--Gray800)",
      "color-bg-base-highlight": "var(--Revital_Blue-2)",
      "color-bg-base-normal-subtle": "var(--White)",
      "color-bg-danger-primary": "var(--Red-500)",
      "color-bg-danger-primary-hover": "var(--Red-600)",
      "color-bg-danger-primary-active": "var(--Red-600)",
      "color-bg-danger-primary-disable": "var(--Gray100)",
      "color-bg-danger-inverse": "var(--Red-200)",
      "color-bg-danger-secondary": "var(--White)",
      "color-bg-danger-secondary-hover": "var(--Red-100)",
      "color-bg-danger-secondary-active": "var(--Red-100)",
      "color-bg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-danger-tertiary": "var(--Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Red-200)",
      "color-bg-danger-tertiary-active": "var(--Red-200)",
      "color-bg-warning-primary": "var(--Orange-500)",
      "color-bg-warning-primary-hover": "var(--Orange-600)",
      "color-bg-warning-primary-active": "var(--Orange-600)",
      "color-bg-warning-primary-disable": "var(--Gray100)",
      "color-bg-warning-inverse": "var(--Orange-200)",
      "color-bg-warning-secondary": "var(--White)",
      "color-bg-warning-secondary-hover": "var(--Orange-100)",
      "color-bg-warning-secondary-active": "var(--Orange-100)",
      "color-bg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-warning-tertiary": "var(--Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Orange-200)",
      "color-bg-success-primary": "var(--Green-500)",
      "color-bg-success-primary-hover": "var(--Green-600)",
      "color-bg-success-primary-active": "var(--Green-600)",
      "color-bg-success-primary-disable": "var(--Gray100)",
      "color-bg-success-inverse": "var(--Green-200)",
      "color-bg-success-secondary": "var(--White)",
      "color-bg-success-secondary-hover": "var(--Green-100)",
      "color-bg-success-secondary-active": "var(--Green-100)",
      "color-bg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-success-tertiary": "var(--Green-100)",
      "color-bg-success-tertiary-hover": "var(--Green-200)",
      "color-bg-success-tertiary-active": "var(--Green-200)",
      "color-bg-info-inverse": "var(--Blue-200)",
      "color-bg-info-primary": "var(--Blue-500)",
      "color-bg-info-primary-hover": "var(--Blue-600)",
      "color-bg-info-primary-active": "var(--Blue-600)",
      "color-bg-info-primary-disable": "var(--Gray100)",
      "color-bg-info-secondary": "var(--White)",
      "color-bg-info-secondary-hover": "var(--Blue-100)",
      "color-bg-info-secondary-active": "var(--Blue-100)",
      "color-bg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-info-tertiary": "var(--Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Blue-200)",
      "color-bg-info-tertiary-active": "var(--Blue-200)",
      "color-bg-decorative-primary": "var(--Revital_Blue-1)",
      "color-bg-decorative-primary-hover": "var(--Revital_Blue-1)",
      "color-bg-decorative-primary-active": "var(--Revital_Blue-1)",
      "color-bg-decorative-disable": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-secondary": "var(--White)",
      "color-bg-decorative-hover": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-active": "rgb(0 0 0 / 0.1)",
      "color-bg-decorative-tertiary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-1": "var(--Revital_Blue-2)",
      "color-bg-decorative-2": "var(--Revital_Blue-2)",
      "color-bg-decorative-3": "var(--Revital_Blue-2)",
      "color-bg-decorative-4": "var(--Revital_Blue-2)",
      "color-bg-decorative-5": "var(--Revital_Blue-2)",
      "color-bg-neutral": "var(--Black)",
      "color-bg-neutral-inverse": "var(--Gray200)",
      "color-bg-brand-light": "var(--Revital_Green-2)",
      "color-bg-brand": "var(--Revital_Blue-2)",
      "color-bg-brand-dark": "var(--Revital_Blue-1)",
      "color-fg-base-primary": "var(--White)",
      "color-fg-base-secondary": "var(--Revital_Blue-1)",
      "color-fg-base-tertiary": "var(--Black)",
      "color-fg-base-active": "var(--White)",
      "color-fg-base-disable": "var(--Gray400)",
      "color-fg-base": "var(--Revital_Blue-1)",
      "color-fg-base-focus": "var(--Revital_Blue-1)",
      "color-fg-base-inverse": "var(--White)",
      "color-fg-base-active-inverse": "var(--Revital_Blue-0)",
      "color-fg-danger-primary": "var(--White)",
      "color-fg-danger": "var(--Red-500)",
      "color-fg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-danger-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-success-primary": "var(--White)",
      "color-fg-success": "var(--Green-500)",
      "color-fg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-success-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-warning-primary": "var(--White)",
      "color-fg-warning": "var(--Orange-500)",
      "color-fg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-warning-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-info-primary": "var(--White)",
      "color-fg-info": "var(--Blue-500)",
      "color-fg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-info-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative": "var(--Black)",
      "color-fg-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative-primary": "var(--White)",
      "color-fg-decorative-secondary": "var(--Revital_Blue-1)",
      "color-fg-decorative-tertiary": "var(--Revital_Blue-1)",
      "color-stroke-base-input": "var(--Gray500)",
      "color-stroke-base-input-hover": "var(--Gray500)",
      "color-stroke-base-input-active": "var(--Gray500)",
      "color-stroke-base-input-disable": "var(--Gray300)",
      "color-stroke-base-main-selected": "var(--Revital_Blue-1)",
      "color-stroke-base-input-focus": "var(--Gray800)",
      "color-stroke-base-main-highlight": "var(--Revital_Blue-2)",
      "color-stroke-base-basic": "var(--Gray300)",
      "color-stroke-base-main": "var(--Revital_Blue-2)",
      "color-stroke-base-main-hover": "var(--Revital_Blue-1)",
      "color-stroke-base-main-active": "var(--Revital_Blue-0)",
      "color-stroke-base-main-disable": "var(--Gray300)",
      "color-stroke-base-input-selected": "var(--Revital_Blue-1)",
      "color-stroke-base-input-highlight": "var(--Revital_Blue-2)",
      "color-stroke-danger": "var(--Red-500)",
      "color-stroke-danger-hover": "var(--Red-600)",
      "color-stroke-danger-active": "var(--Red-600)",
      "color-stroke-success": "var(--Green-500)",
      "color-stroke-success-hover": "var(--Green-600)",
      "color-stroke-success-active": "var(--Green-600)",
      "color-stroke-warning": "var(--Orange-500)",
      "color-stroke-warning-hover": "var(--Orange-600)",
      "color-stroke-warning-active": "var(--Orange-600)",
      "color-stroke-info": "var(--Blue-500)",
      "color-stroke-info-hover": "var(--Blue-600)",
      "color-stroke-info-active": "var(--Blue-600)",
      "color-stroke-decorative": "var(--Revital_Blue-1)",
      "color-stroke-decorative-hover": "var(--Revital_Blue-1)",
      "color-stroke-decorative-active": "var(--Revital_Blue-1)",
      "color-stroke-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-base-tertiary": "var(--Black)",
      "color-text-base-primary": "var(--White)",
      "color-text-base-secondary": "var(--Revital_Blue-1)",
      "color-text-base-main": "var(--Black)",
      "color-text-base-basic": "var(--Gray600)",
      "color-text-base-disable": "var(--Gray500)",
      "color-text-base-link": "var(--Revital_Green-1)",
      "color-text-base-inverse": "var(--White)",
      "color-text-danger-primary": "var(--Red-900)",
      "color-text-danger-secondary": "var(--Red-500)",
      "color-text-success-primary": "var(--Green-900)",
      "color-text-success-secondary": "var(--Green-500)",
      "color-text-warning-primary": "var(--Orange-900)",
      "color-text-warning-secondary": "var(--Orange-500)",
      "color-text-info-primary": "var(--Blue-900)",
      "color-text-info-secondary": "var(--Blue-500)",
      "color-text-decorative-secondary": "var(--Revital_Blue-1)",
      "color-text-decorative-tertiary": "var(--Revital_Blue-1)",
      "color-text-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-decorative-main": "var(--Black)",
      "color-text-decorative-basic": "var(--Gray700)",
      "color-text-decorative-primary": "var(--White)",
      "color-text-decorative-1": "var(--Revital_Blue-2)",
      "color-text-decorative-2": "var(--Revital_Blue-2)",
      "color-text-decorative-3": "var(--Revital_Blue-2)",
      "color-text-decorative-4": "var(--Revital_Blue-2)",
      "color-text-decorative-5": "var(--Revital_Blue-2)"
    },
    "shine": {
      "color-background": "var(--Shine_White)",
      "color-bg-base-primary": "var(--Shine_Gray-900)",
      "color-bg-base-primary-hover": "var(--Shine_Gray-800)",
      "color-bg-base-primary-active": "var(--Shine_Black)",
      "color-bg-base-secondary": "var(--Shine_White)",
      "color-bg-base-secondary-active": "var(--Shine_Grey-5)",
      "color-bg-base-secondary-hover": "var(--Shine_Grey-5)",
      "color-bg-base-tertiary": "var(--Shine_Grey-4)",
      "color-bg-base-tertiary-hover": "var(--Shine_Grey-3)",
      "color-bg-base-tertiary-active": "var(--Shine_Grey-2)",
      "color-bg-base-normal": "var(--Shine_White)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Shine_Gray-900)",
      "color-bg-base-disable": "var(--Shine_Gray-300)",
      "color-bg-base-hover": "var(--Shine_Grey-5)",
      "color-bg-base-focus": "var(--Shine_Grey-4)",
      "color-bg-base-active-disable": "var(--Shine_Gray-400)",
      "color-bg-base-inverse": "var(--Shine_Gray-900)",
      "color-bg-base-highlight": "#25241D80",
      "color-bg-danger-primary": "var(--Shine_Red-600)",
      "color-bg-danger-primary-hover": "var(--Shine_Red-600)",
      "color-bg-danger-primary-active": "var(--Shine_Red-700)",
      "color-bg-danger-primary-disable": "var(--Shine_Gray-300)",
      "color-bg-danger-inverse": "var(--Shine_Red-200)",
      "color-bg-danger-secondary": "var(--Shine_White)",
      "color-bg-danger-secondary-hover": "var(--Shine_Red-100)",
      "color-bg-danger-secondary-active": "var(--Shine_Red-200)",
      "color-bg-danger-secondary-disable": "#00000000",
      "color-bg-danger-tertiary": "var(--Shine_Red-100)",
      "color-bg-danger-tertiary-hover": "var(--Shine_Red-200)",
      "color-bg-danger-tertiary-active": "var(--Shine_Red-300)",
      "color-bg-warning-primary": "var(--Shine_Orange-600)",
      "color-bg-warning-primary-hover": "var(--Shine_Orange-600)",
      "color-bg-warning-primary-active": "var(--Shine_Orange-700)",
      "color-bg-warning-primary-disable": "var(--Shine_Gray-300)",
      "color-bg-warning-inverse": "var(--Shine_Orange-200)",
      "color-bg-warning-secondary": "var(--Shine_White)",
      "color-bg-warning-secondary-hover": "var(--Shine_Orange-100)",
      "color-bg-warning-secondary-active": "var(--Shine_Orange-200)",
      "color-bg-warning-secondary-disable": "#00000000",
      "color-bg-warning-tertiary": "var(--Shine_Orange-100)",
      "color-bg-warning-tertiary-hover": "var(--Shine_Orange-200)",
      "color-bg-warning-tertiary-active": "var(--Shine_Orange-300)",
      "color-bg-success-primary": "var(--Shine_Green-600)",
      "color-bg-success-primary-hover": "var(--Shine_Green-600)",
      "color-bg-success-primary-active": "var(--Shine_Green-700)",
      "color-bg-success-primary-disable": "var(--Shine_Gray-300)",
      "color-bg-success-inverse": "var(--Shine_Green-200)",
      "color-bg-success-secondary": "var(--Shine_White)",
      "color-bg-success-secondary-hover": "var(--Shine_Green-100)",
      "color-bg-success-secondary-active": "var(--Shine_Green-200)",
      "color-bg-success-secondary-disable": "#00000000",
      "color-bg-success-tertiary": "var(--Shine_Green-100)",
      "color-bg-success-tertiary-hover": "var(--Shine_Green-200)",
      "color-bg-success-tertiary-active": "var(--Shine_Green-300)",
      "color-bg-info-inverse": "var(--Shine_Blue-200)",
      "color-bg-info-primary": "var(--Shine_Blue-600)",
      "color-bg-info-primary-hover": "var(--Shine_Blue-600)",
      "color-bg-info-primary-active": "var(--Shine_Blue-700)",
      "color-bg-info-primary-disable": "var(--Shine_Gray-300)",
      "color-bg-info-secondary": "var(--Shine_White)",
      "color-bg-info-secondary-hover": "var(--Shine_Blue-100)",
      "color-bg-info-secondary-active": "var(--Shine_Blue-200)",
      "color-bg-info-secondary-disable": "#00000000",
      "color-bg-info-tertiary": "var(--Shine_Blue-100)",
      "color-bg-info-tertiary-hover": "var(--Shine_Blue-200)",
      "color-bg-info-tertiary-active": "var(--Shine_Blue-300)",
      "color-bg-decorative-primary": "var(--Shine_White)",
      "color-bg-decorative-primary-hover": "var(--Shine_Grey-5)",
      "color-bg-decorative-primary-active": "var(--Shine_Grey-4)",
      "color-bg-decorative-disable": "#00000000",
      "color-bg-decorative-secondary": "#00000000",
      "color-bg-decorative-hover": "#0000000D",
      "color-bg-decorative-active": "#0000001A",
      "color-bg-decorative-tertiary": "#00000000",
      "color-bg-decorative-1": "var(--Shine_Yellow-0)",
      "color-bg-decorative-2": "var(--Shine_Yellow-0)",
      "color-bg-decorative-3": "var(--Shine_Yellow-0)",
      "color-bg-decorative-4": "var(--Shine_Yellow-0)",
      "color-bg-decorative-5": "var(--Shine_Yellow-0)",
      "color-bg-neutral": "var(--Shine_Gray-900)",
      "color-bg-neutral-inverse": "var(--Shine_Grey-5)",
      "color-bg-brand-light": "var(--Shine_Yellow-0)",
      "color-bg-brand": "var(--Shine_Yellow-0)",
      "color-bg-brand-dark": "var(--Shine_Yellow-0)",
      "color-fg-base-primary": "var(--Shine_White)",
      "color-fg-base-secondary": "var(--Shine_Gray-900)",
      "color-fg-base-tertiary": "var(--Shine_Gray-900)",
      "color-fg-base-active": "var(--Shine_White)",
      "color-fg-base-disable": "var(--Shine_Gray-600)",
      "color-fg-base": "var(--Shine_Gray-900)",
      "color-fg-base-focus": "var(--Shine_Gray-900)",
      "color-fg-base-inverse": "var(--Shine_White)",
      "color-fg-base-active-inverse": "var(--Shine_Gray-900)",
      "color-fg-danger-primary": "var(--Shine_White)",
      "color-fg-danger": "var(--Shine_Red-600)",
      "color-fg-danger-secondary-disable": "#00000000",
      "color-fg-danger-tertiary-disable": "#00000040",
      "color-fg-success-primary": "var(--Shine_White)",
      "color-fg-success": "var(--Shine_Green-600)",
      "color-fg-success-secondary-disable": "#00000000",
      "color-fg-success-tertiary-disable": "#00000040",
      "color-fg-warning-primary": "var(--Shine_White)",
      "color-fg-warning": "var(--Shine_Orange-600)",
      "color-fg-warning-secondary-disable": "#00000000",
      "color-fg-warning-tertiary-disable": "#00000040",
      "color-fg-info-primary": "var(--Shine_White)",
      "color-fg-info": "var(--Shine_Blue-600)",
      "color-fg-info-secondary-disable": "#00000000",
      "color-fg-info-tertiary-disable": "#00000040",
      "color-fg-decorative": "var(--Shine_Gray-900)",
      "color-fg-decorative-disable": "#00000040",
      "color-stroke-base-input": "var(--Shine_Gray-300)",
      "color-stroke-base-input-hover": "var(--Shine_Gray-300)",
      "color-stroke-base-input-active": "var(--Shine_Gray-900)",
      "color-stroke-base-input-disable": "var(--Shine_Gray-600)",
      "color-stroke-base-main-selected": "var(--Shine_Gray-900)",
      "color-stroke-base-input-focus": "var(--Shine_Blue-600)",
      "color-stroke-base-main-highlight": "var(--Shine_Gray-900)",
      "color-stroke-base-basic": "var(--Shine_Gray-300)",
      "color-stroke-base-main": "var(--Shine_Gray-300)",
      "color-stroke-base-main-hover": "var(--Shine_Gray-300)",
      "color-stroke-base-main-active": "var(--Shine_Gray-900)",
      "color-stroke-base-main-disable": "var(--Shine_Gray-600)",
      "color-stroke-base-input-selected": "var(--Shine_Gray-900)",
      "color-stroke-base-input-highlight": "var(--Shine_Gray-900)",
      "color-stroke-danger": "var(--Shine_Red-600)",
      "color-stroke-danger-hover": "var(--Shine_Red-700)",
      "color-stroke-danger-active": "var(--Shine_Red-800)",
      "color-stroke-success": "var(--Shine_Green-600)",
      "color-stroke-success-hover": "var(--Shine_Green-700)",
      "color-stroke-success-active": "var(--Shine_Green-800)",
      "color-stroke-warning": "var(--Shine_Orange-600)",
      "color-stroke-warning-hover": "var(--Shine_Orange-700)",
      "color-stroke-warning-active": "var(--Shine_Orange-800)",
      "color-stroke-info": "var(--Shine_Blue-600)",
      "color-stroke-info-hover": "var(--Shine_Blue-700)",
      "color-stroke-info-active": "var(--Shine_Blue-800)",
      "color-stroke-decorative": "#00000026",
      "color-stroke-decorative-hover": "#00000040",
      "color-stroke-decorative-active": "#00000080",
      "color-stroke-decorative-disable": "#00000040",
      "color-text-base-tertiary": "var(--Shine_Gray-900)",
      "color-text-base-primary": "var(--Shine_White)",
      "color-text-base-secondary": "var(--Shine_Gray-900)",
      "color-text-base-main": "var(--Shine_Gray-900)",
      "color-text-base-basic": "var(--Shine_Gray-800)",
      "color-text-base-disable": "var(--Shine_Gray-600)",
      "color-text-base-link": "var(--Shine_Gray-900)",
      "color-text-danger-primary": "var(--Shine_Red-700)",
      "color-text-danger-secondary": "var(--Shine_Red-600)",
      "color-text-success-primary": "var(--Shine_Green-700)",
      "color-text-success-secondary": "var(--Shine_Green-600)",
      "color-text-warning-primary": "var(--Shine_Orange-700)",
      "color-text-warning-secondary": "var(--Shine_Orange-600)",
      "color-text-info-primary": "var(--Shine_Blue-700)",
      "color-text-info-secondary": "var(--Shine_Blue-600)",
      "color-text-decorative-secondary": "var(--Shine_Gray-900)",
      "color-text-decorative-tertiary": "var(--Shine_Gray-900)",
      "color-text-decorative-disable": "#00000040",
      "color-text-decorative-main": "var(--Shine_Gray-900)",
      "color-text-decorative-basic": "var(--Shine_Gray-800)",
      "color-text-decorative-primary": "var(--Shine_Gray-900)",
      "color-text-decorative-1": "var(--Shine_Yellow-1)",
      "color-text-decorative-2": "var(--Shine_Yellow-1)",
      "color-text-decorative-3": "var(--Shine_Yellow-1)",
      "color-text-decorative-4": "var(--Shine_Yellow-1)",
      "color-text-decorative-5": "var(--Shine_Yellow-1)"
    },
    "sidecare": {
      "color-background": "var(--Sidecare_Legacy-bg)",
      "color-bg-base-primary": "var(--Sidecare_Legacy-primary_500)",
      "color-bg-base-primary-hover": "var(--Sidecare_Legacy-primary_600)",
      "color-bg-base-primary-active": "var(--Sidecare_Legacy-primary_700)",
      "color-bg-base-secondary": "var(--Sidecare_Legacy-white)",
      "color-bg-base-secondary-active": "var(--Sidecare_Legacy-primary_100)",
      "color-bg-base-secondary-hover": "var(--Sidecare_Legacy-primary_100)",
      "color-bg-base-tertiary": "var(--Sidecare_Legacy-primary_200)",
      "color-bg-base-tertiary-hover": "rgb(214, 208, 240)",
      "color-bg-base-tertiary-active": "var(--Sidecare_Legacy-primary_300)",
      "color-bg-base-normal": "var(--Sidecare_Legacy-white)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Sidecare_Legacy-primary_500)",
      "color-bg-base-disable": "var(--Sidecare_Legacy-gray_200)",
      "color-bg-base-hover": "var(--Sidecare_Legacy-primary_100)",
      "color-bg-base-focus": "var(--Sidecare_Legacy-primary_100)",
      "color-bg-base-active-disable": "var(--Sidecare_Legacy-gray_300)",
      "color-bg-base-inverse": "var(--Sidecare_Legacy-primary_900)",
      "color-bg-base-highlight": "#FF7B4480",
      "color-bg-danger-primary": "var(--Sidecare_Legacy-red_600)",
      "color-bg-danger-primary-hover": "var(--Sidecare_Legacy-red_700)",
      "color-bg-danger-primary-active": "var(--Sidecare_Legacy-red_800)",
      "color-bg-danger-primary-disable": "var(--Sidecare_Legacy-gray_100)",
      "color-bg-danger-inverse": "var(--Sidecare_Legacy-red_100)",
      "color-bg-danger-secondary": "var(--Sidecare_Legacy-white)",
      "color-bg-danger-secondary-hover": "var(--Sidecare_Legacy-red_100)",
      "color-bg-danger-secondary-active": "var(--Sidecare_Legacy-red_200)",
      "color-bg-danger-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-danger-tertiary": "var(--Sidecare_Legacy-red_100)",
      "color-bg-danger-tertiary-hover": "var(--Sidecare_Legacy-red_200)",
      "color-bg-danger-tertiary-active": "var(--Sidecare_Legacy-red_300)",
      "color-bg-warning-primary": "var(--Sidecare_Legacy-orange_600)",
      "color-bg-warning-primary-hover": "var(--Sidecare_Legacy-orange_700)",
      "color-bg-warning-primary-active": "var(--Sidecare_Legacy-orange_800)",
      "color-bg-warning-primary-disable": "var(--Sidecare_Legacy-gray_100)",
      "color-bg-warning-inverse": "var(--Sidecare_Legacy-orange_100)",
      "color-bg-warning-secondary": "var(--Sidecare_Legacy-white)",
      "color-bg-warning-secondary-hover": "var(--Sidecare_Legacy-orange_100)",
      "color-bg-warning-secondary-active": "var(--Sidecare_Legacy-orange_200)",
      "color-bg-warning-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-warning-tertiary": "var(--Sidecare_Legacy-orange_100)",
      "color-bg-warning-tertiary-hover": "var(--Sidecare_Legacy-orange_200)",
      "color-bg-warning-tertiary-active": "var(--Sidecare_Legacy-orange_300)",
      "color-bg-success-primary": "var(--Sidecare_Legacy-green_600)",
      "color-bg-success-primary-hover": "var(--Sidecare_Legacy-green_700)",
      "color-bg-success-primary-active": "var(--Sidecare_Legacy-green_800)",
      "color-bg-success-primary-disable": "var(--Sidecare_Legacy-gray_100)",
      "color-bg-success-inverse": "var(--Sidecare_Legacy-green_100)",
      "color-bg-success-secondary": "var(--Sidecare_Legacy-white)",
      "color-bg-success-secondary-hover": "var(--Sidecare_Legacy-green_100)",
      "color-bg-success-secondary-active": "var(--Sidecare_Legacy-green_200)",
      "color-bg-success-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-success-tertiary": "var(--Sidecare_Legacy-green_100)",
      "color-bg-success-tertiary-hover": "var(--Sidecare_Legacy-green_200)",
      "color-bg-success-tertiary-active": "var(--Sidecare_Legacy-green_300)",
      "color-bg-info-inverse": "var(--Sidecare_Legacy-primary_200)",
      "color-bg-info-primary": "var(--Sidecare_Legacy-primary_600)",
      "color-bg-info-primary-hover": "var(--Sidecare_Legacy-primary_700)",
      "color-bg-info-primary-active": "var(--Sidecare_Legacy-primary_800)",
      "color-bg-info-primary-disable": "var(--Sidecare_Legacy-gray_100)",
      "color-bg-info-secondary": "var(--Sidecare_Legacy-white)",
      "color-bg-info-secondary-hover": "var(--Sidecare_Legacy-primary_100)",
      "color-bg-info-secondary-active": "var(--Sidecare_Legacy-primary_200)",
      "color-bg-info-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-info-tertiary": "var(--Sidecare_Legacy-primary_100)",
      "color-bg-info-tertiary-hover": "var(--Sidecare_Legacy-primary_200)",
      "color-bg-info-tertiary-active": "var(--Sidecare_Legacy-primary_300)",
      "color-bg-decorative-primary": "var(--Sidecare_Legacy-white)",
      "color-bg-decorative-primary-hover": "var(--Sidecare_Legacy-gray_100)",
      "color-bg-decorative-primary-active": "var(--Sidecare_Legacy-gray_200)",
      "color-bg-decorative-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-decorative-secondary": "rgbaa(0, 0, 0, 0)",
      "color-bg-decorative-hover": "rgbaa(0, 0, 0, 0.05)",
      "color-bg-decorative-active": "rgbaa(0, 0, 0, 0.1)",
      "color-bg-decorative-tertiary": "rgbaa(0, 0, 0, 0)",
      "color-bg-decorative-1": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-decorative-2": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-decorative-3": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-decorative-4": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-decorative-5": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-neutral": "var(--Sidecare_Legacy-gray_800)",
      "color-bg-neutral-inverse": "var(--Sidecare_Legacy-gray_100)",
      "color-bg-brand-light": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-brand": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-bg-brand-dark": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-fg-base-primary": "var(--Sidecare_Legacy-white)",
      "color-fg-base-secondary": "var(--Sidecare_Legacy-primary_900)",
      "color-fg-base-tertiary": "var(--Sidecare_Legacy-primary_900)",
      "color-fg-base-active": "var(--Sidecare_white)",
      "color-fg-base-disable": "var(--Sidecare_Legacy-gray_500)",
      "color-fg-base": "var(--Sidecare_primary_900)",
      "color-fg-base-focus": "var(--Sidecare_Legacy-primary_900)",
      "color-fg-base-inverse": "var(--Sidecare_Legacy-white)",
      "color-fg-base-active-inverse": "var(--Sidecare_Legacy-primary_500)",
      "color-fg-danger-primary": "var(--Sidecare_white)",
      "color-fg-danger": "var(--Sidecare_Legacy-red_600)",
      "color-fg-danger-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-danger-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-success-primary": "var(--Sidecare_Legacy-white)",
      "color-fg-success": "var(--Sidecare_Legacy-green_600)",
      "color-fg-success-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-success-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-warning-primary": "var(--Sidecare_Legacy-white)",
      "color-fg-warning": "var(--Sidecare_Legacy-orange_600)",
      "color-fg-warning-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-warning-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-info-primary": "var(--Sidecare_Legacy-white)",
      "color-fg-info": "var(--Sidecare_Legacy-primary_600)",
      "color-fg-info-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-info-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-decorative": "var(--Sidecare_Legacy-gray_900)",
      "color-fg-decorative-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-stroke-base-input": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-input-hover": "var(--Sidecare_Legacy-gray_400)",
      "color-stroke-base-input-active": "var(--Sidecare_Legacy-gray_500)",
      "color-stroke-base-input-disable": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-main-selected": "var(--Sidecare_Legacy-primary_500)",
      "color-stroke-base-input-focus": "var(--Sidecare_Legacy-primary_500)",
      "color-stroke-base-main-highlight": "var(--Sidecare_Legacy-primary_500)",
      "color-stroke-base-basic": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-main": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-main-hover": "var(--Sidecare_Legacy-gray_400)",
      "color-stroke-base-main-active": "var(--Sidecare_Legacy-gray_500)",
      "color-stroke-base-main-disable": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-input-selected": "var(--Sidecare_Legacy-primary_500)",
      "color-stroke-base-input-highlight": "var(--Sidecare_Legacy-primary_500)",
      "color-stroke-danger": "var(--Sidecare_Legacy-red_600)",
      "color-stroke-danger-hover": "var(--Sidecare_Legacy-red_700)",
      "color-stroke-danger-active": "var(--Sidecare_Legacy-red_800)",
      "color-stroke-success": "var(--Sidecare_Legacy-green_600)",
      "color-stroke-success-hover": "var(--Sidecare_Legacy-green_700)",
      "color-stroke-success-active": "var(--Sidecare_Legacy-green_800)",
      "color-stroke-warning": "var(--Sidecare_Legacy-orange-600)",
      "color-stroke-warning-hover": "var(--Sidecare_Legacy-orange-700)",
      "color-stroke-warning-active": "var(--Sidecare_Legacy-orange-800)",
      "color-stroke-info": "var(--Sidecare_Legacy-primary_600)",
      "color-stroke-info-hover": "var(--Sidecare_Legacy-primary_700)",
      "color-stroke-info-active": "var(--Sidecare_Legacy-primary_800)",
      "color-stroke-decorative": "rgbaa(0, 0, 0, 0.15)",
      "color-stroke-decorative-hover": "rgbaa(0, 0, 0, 0.25)",
      "color-stroke-decorative-active": "rgbaa(0, 0, 0, 0.5)",
      "color-stroke-decorative-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-text-base-tertiary": "var(--Sidecare_Legacy-primary_900)",
      "color-text-base-primary": "var(--Sidecare_Legacy-white)",
      "color-text-base-secondary": "var(--Sidecare_Legacy-primary_900)",
      "color-text-base-main": "var(--Sidecare_Legacy-primary_900)",
      "color-text-base-basic": "var(--Sidecare_Legacy-gray_800)",
      "color-text-base-disable": "var(--Sidecare_Legacy-gray_500)",
      "color-text-base-link": "var(--Sidecare_Legacy-primary_500)",
      "color-text-danger-primary": "var(--Sidecare_Legacy-red_800)",
      "color-text-danger-secondary": "var(--Sidecare_Legacy-red_600)",
      "color-text-success-primary": "var(--Sidecare_Legacy-green_800)",
      "color-text-success-secondary": "var(--Sidecare_Legacy-green_600)",
      "color-text-warning-primary": "var(--Sidecare_Legacy-orange_800)",
      "color-text-warning-secondary": "var(--Sidecare_Legacy-orange_600)",
      "color-text-info-primary": "var(--Sidecare_Legacy-primary_800)",
      "color-text-info-secondary": "var(--Sidecare_Legacy-primary_600)",
      "color-text-decorative-secondary": "var(--Sidecare_Legacy-gray_900)",
      "color-text-decorative-tertiary": "var(--Sidecare_Legacy-white)",
      "color-text-decorative-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-text-decorative-main": "var(--Sidecare_Legacy-decorative_primary)",
      "color-text-decorative-basic": "var(--Sidecare_Legacy-decorative_primary)",
      "color-text-decorative-primary": "var(--Sidecare_Legacy-gray_900)",
      "color-text-decorative-1": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-text-decorative-2": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-text-decorative-3": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-text-decorative-4": "var(--Sidecare_Legacy-decorative_secondary)",
      "color-text-decorative-5": "var(--Sidecare_Legacy-decorative_secondary)"
    },
    "superindep": {
      "color-background": "var(--Superindep_Legacy-bg)",
      "color-bg-base-primary": "var(--Superindep_Legacy-primary_500)",
      "color-bg-base-primary-hover": "var(--Superindep_Legacy-primary_600)",
      "color-bg-base-primary-active": "var(--Superindep_Legacy-primary_700)",
      "color-bg-base-secondary": "var(--Superindep_Legacy-white)",
      "color-bg-base-secondary-active": "var(--Superindep_Legacy-primary_100)",
      "color-bg-base-secondary-hover": "var(--Superindep_Legacy-primary_100)",
      "color-bg-base-tertiary": "var(--Superindep_Legacy-primary_200)",
      "color-bg-base-tertiary-hover": "rgb(214, 208, 240)",
      "color-bg-base-tertiary-active": "var(--Superindep_Legacy-primary_300)",
      "color-bg-base-normal": "var(--Superindep_Legacy-white)",
      "color-bg-base-normal-subtle": "var(--Gray-50)",
      "color-bg-base-active": "var(--Superindep_Legacy-primary_500)",
      "color-bg-base-disable": "var(--Superindep_Legacy-gray_200)",
      "color-bg-base-hover": "var(--Superindep_Legacy-primary_100)",
      "color-bg-base-focus": "var(--Superindep_Legacy-primary_100)",
      "color-bg-base-active-disable": "var(--Superindep_Legacy-gray_300)",
      "color-bg-base-inverse": "var(--Superindep_Legacy-primary_900)",
      "color-bg-base-highlight": "#1F0F6980",
      "color-bg-danger-primary": "var(--Superindep_Legacy-red_600)",
      "color-bg-danger-primary-hover": "var(--Superindep_Legacy-red_700)",
      "color-bg-danger-primary-active": "var(--Superindep_Legacy-red_800)",
      "color-bg-danger-primary-disable": "var(--Superindep_Legacy-gray_100)",
      "color-bg-danger-inverse": "var(--Superindep_Legacy-red_100)",
      "color-bg-danger-secondary": "var(--Superindep_Legacy-white)",
      "color-bg-danger-secondary-hover": "var(--Superindep_Legacy-red_100)",
      "color-bg-danger-secondary-active": "var(--Superindep_Legacy-red_200)",
      "color-bg-danger-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-danger-tertiary": "var(--Superindep_Legacy-red_100)",
      "color-bg-danger-tertiary-hover": "var(--Superindep_Legacy-red_200)",
      "color-bg-danger-tertiary-active": "var(--Superindep_Legacy-red_300)",
      "color-bg-warning-primary": "var(--Superindep_Legacy-orange_600)",
      "color-bg-warning-primary-hover": "var(--Superindep_Legacy-orange_700)",
      "color-bg-warning-primary-active": "var(--Superindep_Legacy-orange_800)",
      "color-bg-warning-primary-disable": "var(--Superindep_Legacy-gray_100)",
      "color-bg-warning-inverse": "var(--Superindep_Legacy-orange_100)",
      "color-bg-warning-secondary": "var(--Superindep_Legacy-white)",
      "color-bg-warning-secondary-hover": "var(--Superindep_Legacy-orange_100)",
      "color-bg-warning-secondary-active": "var(--Superindep_Legacy-orange_200)",
      "color-bg-warning-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-warning-tertiary": "var(--Superindep_Legacy-orange_100)",
      "color-bg-warning-tertiary-hover": "var(--Superindep_Legacy-orange_200)",
      "color-bg-warning-tertiary-active": "var(--Superindep_Legacy-orange_300)",
      "color-bg-success-primary": "var(--Superindep_Legacy-green_600)",
      "color-bg-success-primary-hover": "var(--Superindep_Legacy-green_700)",
      "color-bg-success-primary-active": "var(--Superindep_Legacy-green_800)",
      "color-bg-success-primary-disable": "var(--Superindep_Legacy-gray_100)",
      "color-bg-success-inverse": "var(--Superindep_Legacy-green_100)",
      "color-bg-success-secondary": "var(--Superindep_Legacy-white)",
      "color-bg-success-secondary-hover": "var(--Superindep_Legacy-green_100)",
      "color-bg-success-secondary-active": "var(--Superindep_Legacy-green_200)",
      "color-bg-success-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-success-tertiary": "var(--Superindep_Legacy-green_100)",
      "color-bg-success-tertiary-hover": "var(--Superindep_Legacy-green_200)",
      "color-bg-success-tertiary-active": "var(--Superindep_Legacy-green_300)",
      "color-bg-info-inverse": "var(--Superindep_Legacy-primary_200)",
      "color-bg-info-primary": "var(--Superindep_Legacy-primary_600)",
      "color-bg-info-primary-hover": "var(--Superindep_Legacy-primary_700)",
      "color-bg-info-primary-active": "var(--Superindep_Legacy-primary_800)",
      "color-bg-info-primary-disable": "var(--Superindep_Legacy-gray_100)",
      "color-bg-info-secondary": "var(--Superindep_Legacy-white)",
      "color-bg-info-secondary-hover": "var(--Superindep_Legacy-primary_100)",
      "color-bg-info-secondary-active": "var(--Superindep_Legacy-primary_200)",
      "color-bg-info-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-info-tertiary": "var(--Superindep_Legacy-primary_100)",
      "color-bg-info-tertiary-hover": "var(--Superindep_Legacy-primary_200)",
      "color-bg-info-tertiary-active": "var(--Superindep_Legacy-primary_300)",
      "color-bg-decorative-primary": "var(--Superindep_Legacy-white)",
      "color-bg-decorative-primary-hover": "var(--Superindep_Legacy-gray_100)",
      "color-bg-decorative-primary-active": "var(--Superindep_Legacy-gray_200)",
      "color-bg-decorative-disable": "rgbaa(0, 0, 0, 0)",
      "color-bg-decorative-secondary": "rgbaa(0, 0, 0, 0)",
      "color-bg-decorative-hover": "rgbaa(0, 0, 0, 0.05)",
      "color-bg-decorative-active": "rgbaa(0, 0, 0, 0.1)",
      "color-bg-decorative-tertiary": "rgbaa(0, 0, 0, 0)",
      "color-bg-decorative-1": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-decorative-2": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-decorative-3": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-decorative-4": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-decorative-5": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-neutral": "var(--Superindep_Legacy-gray_800)",
      "color-bg-neutral-inverse": "var(--Superindep_Legacy-gray_100)",
      "color-bg-brand-light": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-brand": "var(--Superindep_Legacy-decorative_secondary)",
      "color-bg-brand-dark": "var(--Superindep_Legacy-decorative_secondary)",
      "color-fg-base-primary": "var(--Superindep_Legacy-white)",
      "color-fg-base-secondary": "var(--Superindep_Legacy-primary_900)",
      "color-fg-base-tertiary": "var(--Superindep_Legacy-primary_900)",
      "color-fg-base-active": "var(--Superindep_Legacy-white)",
      "color-fg-base-disable": "var(--Superindep_Legacy-gray_500)",
      "color-fg-base": "var(--Superindep_Legacy-primary_900)",
      "color-fg-base-focus": "var(--Superindep_Legacy-primary_900)",
      "color-fg-base-inverse": "var(--Superindep_Legacy-white)",
      "color-fg-base-active-inverse": "var(--Superindep_Legacy-primary_500)",
      "color-fg-danger-primary": "var(--Superindep_Legacy-white)",
      "color-fg-danger": "var(--Superindep_Legacy-red_600)",
      "color-fg-danger-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-danger-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-success-primary": "var(--Superindep_Legacy-white)",
      "color-fg-success": "var(--Superindep_Legacy-green_600)",
      "color-fg-success-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-success-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-warning-primary": "var(--Superindep_Legacy-white)",
      "color-fg-warning": "var(--Superindep_Legacy-orange_600)",
      "color-fg-warning-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-warning-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-info-primary": "var(--Superindep_Legacy-white)",
      "color-fg-info": "var(--Superindep_Legacy-primary_600)",
      "color-fg-info-secondary-disable": "rgbaa(0, 0, 0, 0)",
      "color-fg-info-tertiary-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-fg-decorative": "var(--Superindep_Legacy-gray_900)",
      "color-fg-decorative-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-stroke-base-input": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-input-hover": "var(--Sidecare_Legacy-gray_400)",
      "color-stroke-base-input-active": "var(--Sidecare_Legacy-gray_500)",
      "color-stroke-base-input-disable": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-main-selected": "var(--Sidecare_Legacy-primary_800)",
      "color-stroke-base-input-focus": "var(--Sidecare_Legacy-primary_800)",
      "color-stroke-base-main-highlight": "var(--Sidecare_Legacy-primary_800)",
      "color-stroke-base-basic": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-main": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-main-hover": "var(--Sidecare_Legacy-gray_400)",
      "color-stroke-base-main-active": "var(--Sidecare_Legacy-gray_500)",
      "color-stroke-base-main-disable": "var(--Sidecare_Legacy-gray_300)",
      "color-stroke-base-input-selected": "var(--Sidecare_Legacy-primary_800)",
      "color-stroke-base-input-highlight": "var(--Sidecare_Legacy-primary_800)",
      "color-stroke-danger": "var(--Superindep_Legacy-red_600)",
      "color-stroke-danger-hover": "var(--Superindep_Legacy-red_700)",
      "color-stroke-danger-active": "var(--Superindep_Legacy-red_800)",
      "color-stroke-success": "var(--Superindep_Legacy-green_600)",
      "color-stroke-success-hover": "var(--Superindep_Legacy-green_700)",
      "color-stroke-success-active": "var(--Superindep_Legacy-green_800)",
      "color-stroke-warning": "var(--Superindep_Legacy-orange-600)",
      "color-stroke-warning-hover": "var(--Superindep_Legacy-orange-700)",
      "color-stroke-warning-active": "var(--Superindep_Legacy-orange-800)",
      "color-stroke-info": "var(--Superindep_Legacy-primary_600)",
      "color-stroke-info-hover": "var(--Superindep_Legacy-primary_700)",
      "color-stroke-info-active": "var(--Superindep_Legacy-primary_800)",
      "color-stroke-decorative": "rgbaa(0, 0, 0, 0.15)",
      "color-stroke-decorative-hover": "rgbaa(0, 0, 0, 0.25)",
      "color-stroke-decorative-active": "rgbaa(0, 0, 0, 0.5)",
      "color-stroke-decorative-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-text-base-tertiary": "var(--Superindep_Legacy-primary_900)",
      "color-text-base-primary": "var(--Superindep_Legacy-white)",
      "color-text-base-secondary": "var(--Superindep_Legacy-primary_900)",
      "color-text-base-main": "var(--Superindep_Legacy-primary_900)",
      "color-text-base-basic": "var(--Superindep_Legacy-gray_800)",
      "color-text-base-disable": "var(--Superindep_Legacy-gray_500)",
      "color-text-base-link": "var(--Superindep_Legacy-primary_500)",
      "color-text-danger-primary": "var(--Superindep_Legacy-red_800)",
      "color-text-danger-secondary": "var(--Superindep_Legacy-red_600)",
      "color-text-success-primary": "var(--Superindep_Legacy-green_800)",
      "color-text-success-secondary": "var(--Superindep_Legacy-green_600)",
      "color-text-warning-primary": "var(--Superindep_Legacy-orange_800)",
      "color-text-warning-secondary": "var(--Superindep_Legacy-orange_600)",
      "color-text-info-primary": "var(--Superindep_Legacy-primary_800)",
      "color-text-info-secondary": "var(--Superindep_Legacy-primary_600)",
      "color-text-decorative-secondary": "var(--Superindep_Legacy-gray_900)",
      "color-text-decorative-tertiary": "var(--Superindep_Legacy-white)",
      "color-text-decorative-disable": "rgbaa(0, 0, 0, 0.25)",
      "color-text-decorative-main": "var(--Superindep_Legacy-decorative_primary)",
      "color-text-decorative-basic": "var(--Superindep_Legacy-decorative_primary)",
      "color-text-decorative-primary": "var(--Superindep_Legacy-gray_900)",
      "color-text-decorative-1": "var(--Superindep_Legacy-decorative_secondary)",
      "color-text-decorative-2": "var(--Superindep_Legacy-decorative_secondary)",
      "color-text-decorative-3": "var(--Superindep_Legacy-decorative_secondary)",
      "color-text-decorative-4": "var(--Superindep_Legacy-decorative_secondary)",
      "color-text-decorative-5": "var(--Superindep_Legacy-decorative_secondary)"
    },
    "tiime": {
      "color-background": "var(--White)",
      "color-bg-base-primary": "var(--Tiime_Decorative_Marine)",
      "color-bg-base-primary-hover": "var(--Tiime_Secondaires_Marine)",
      "color-bg-base-primary-active": "var(--Tiime_Secondaires_Marine)",
      "color-bg-base-secondary": "var(--White)",
      "color-bg-base-secondary-active": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-base-secondary-hover": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-base-tertiary": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-base-tertiary-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-base-tertiary-active": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-base-normal": "var(--White)",
      "color-bg-base-active": "var(--Tiime_Secondaires_Marine)",
      "color-bg-base-disable": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-base-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-base-focus": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-base-active-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-bg-base-inverse": "var(--Tiime_Decorative_Marine)",
      "color-bg-base-highlight": "var(--Tiime_Secondaires_Gris-500)",
      "color-bg-base-normal-subtle": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-danger-primary": "var(--Tiime_Decorative_rose)",
      "color-bg-danger-primary-hover": "var(--Tiime_Decorative_rose)",
      "color-bg-danger-primary-active": "var(--Tiime_Decorative_rose)",
      "color-bg-danger-primary-disable": "var(--Tiime_Secondaires_Gris-200)",
      "color-bg-danger-inverse": "var(--Tiime_Decorative_rose-light)",
      "color-bg-danger-secondary": "var(--White)",
      "color-bg-danger-secondary-hover": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-danger-secondary-active": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-danger-tertiary": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-danger-tertiary-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-danger-tertiary-active": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-warning-primary": "var(--Tiime_Decorative_jaune)",
      "color-bg-warning-primary-hover": "var(--Tiime_Decorative_jaune)",
      "color-bg-warning-primary-active": "var(--Tiime_Decorative_jaune)",
      "color-bg-warning-primary-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-bg-warning-inverse": "var(--Tiime_Decorative_jaune-light)",
      "color-bg-warning-secondary": "var(--White)",
      "color-bg-warning-secondary-hover": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-warning-secondary-active": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-warning-tertiary": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-warning-tertiary-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-warning-tertiary-active": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-success-primary": "var(--Tiime_Decorative_vert)",
      "color-bg-success-primary-hover": "var(--Tiime_Decorative_vert)",
      "color-bg-success-primary-active": "var(--Tiime_Decorative_vert)",
      "color-bg-success-primary-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-bg-success-inverse": "var(--Tiime_Decorative_vert-light)",
      "color-bg-success-secondary": "var(--White)",
      "color-bg-success-secondary-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-success-secondary-active": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-success-tertiary": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-success-tertiary-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-success-tertiary-active": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-info-inverse": "var(--Tiime_Decorative_bleu-light)",
      "color-bg-info-primary": "var(--Tiime_Decorative_bleu)",
      "color-bg-info-primary-hover": "var(--Tiime_Decorative_bleu)",
      "color-bg-info-primary-active": "var(--Tiime_Decorative_bleu)",
      "color-bg-info-primary-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-bg-info-secondary": "var(--White)",
      "color-bg-info-secondary-hover": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-info-secondary-active": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-bg-info-tertiary": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-info-tertiary-hover": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-info-tertiary-active": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-decorative-primary": "var(--Tiime_Decorative_Marine)",
      "color-bg-decorative-primary-hover": "var(--Tiime_Secondaires_Marine)",
      "color-bg-decorative-primary-active": "var(--Tiime_Secondaires_Marine)",
      "color-bg-decorative-disable": "rgb(0 0 0 / 0)",
      "color-bg-decorative-secondary": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-decorative-hover": "rgb(0 0 0 / 0.05)",
      "color-bg-decorative-active": "rgb(0 0 0 / 0.1)",
      "color-bg-decorative-tertiary": "rgb(0 0 0 / 0)",
      "color-bg-decorative-1": "var(--Tiime_Decorative_violet)",
      "color-bg-decorative-2": "var(--Tiime_Decorative_bleu)",
      "color-bg-decorative-3": "var(--Tiime_Decorative_vert)",
      "color-bg-decorative-4": "var(--Tiime_Decorative_jaune)",
      "color-bg-decorative-5": "var(--Tiime_Decorative_orange)",
      "color-bg-neutral": "var(--Tiime_Decorative_Marine)",
      "color-bg-neutral-inverse": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-brand-light": "var(--Tiime_Secondaires_Gris-50)",
      "color-bg-brand": "var(--Tiime_Secondaires_Gris-100)",
      "color-bg-brand-dark": "var(--Tiime_Decorative_Marine)",
      "color-fg-base-primary": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-base-secondary": "var(--Tiime_Decorative_Marine)",
      "color-fg-base-tertiary": "var(--Tiime_Decorative_Marine)",
      "color-fg-base-active": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-base-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-fg-base": "var(--Tiime_Decorative_Marine)",
      "color-fg-base-focus": "var(--Tiime_Decorative_Marine)",
      "color-fg-base-inverse": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-base-active-inverse": "var(--Tiime_Decorative_Marine)",
      "color-fg-danger-primary": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-danger": "var(--Tiime_Decorative_rose-dark)",
      "color-fg-danger-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-danger-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-success-primary": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-success": "var(--Tiime_Decorative_vert-dark)",
      "color-fg-success-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-success-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-warning-primary": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-warning": "var(--Tiime_Decorative_jaune-dark)",
      "color-fg-warning-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-warning-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-info-primary": "var(--Tiime_Secondaires_Gris-50)",
      "color-fg-info": "var(--Tiime_Decorative_bleu-dark)",
      "color-fg-info-secondary-disable": "rgb(0 0 0 / 0)",
      "color-fg-info-tertiary-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative": "var(--Tiime_Decorative_Marine)",
      "color-fg-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-fg-decorative-primary": "var(--White)",
      "color-fg-decorative-secondary": "var(--Tiime_Decorative_Marine)",
      "color-fg-decorative-tertiary": "var(--Tiime_Decorative_Marine)",
      "color-stroke-base-input": "var(--Tiime_Secondaires_Gris-300)",
      "color-stroke-base-input-hover": "var(--Tiime_Secondaires_Gris-500)",
      "color-stroke-base-input-active": "var(--Tiime_Secondaires_Gris-500)",
      "color-stroke-base-input-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-stroke-base-main-selected": "var(--Tiime_Decorative_Marine)",
      "color-stroke-base-input-focus": "var(--Tiime_Decorative_Marine)",
      "color-stroke-base-main-highlight": "var(--Tiime_Secondaires_Marine)",
      "color-stroke-base-basic": "var(--Tiime_Secondaires_Gris-200)",
      "color-stroke-base-main": "var(--Tiime_Secondaires_Gris-200)",
      "color-stroke-base-main-hover": "var(--Tiime_Secondaires_Gris-300)",
      "color-stroke-base-main-active": "var(--Tiime_Secondaires_Gris-300)",
      "color-stroke-base-main-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-stroke-base-input-selected": "var(--Tiime_Secondaires_Marine)",
      "color-stroke-base-input-highlight": "var(--Tiime_Secondaires_Marine)",
      "color-stroke-danger": "var(--Tiime_Decorative_rose)",
      "color-stroke-danger-hover": "var(--Tiime_Decorative_rose-dark)",
      "color-stroke-danger-active": "var(--Tiime_Decorative_rose-dark)",
      "color-stroke-success": "var(--Tiime_Decorative_vert)",
      "color-stroke-success-hover": "var(--Tiime_Decorative_vert-dark)",
      "color-stroke-success-active": "var(--Tiime_Decorative_vert-dark)",
      "color-stroke-warning": "var(--Tiime_Decorative_jaune)",
      "color-stroke-warning-hover": "var(--Tiime_Decorative_jaune-dark)",
      "color-stroke-warning-active": "var(--Tiime_Decorative_jaune-dark)",
      "color-stroke-info": "var(--Tiime_Decorative_bleu)",
      "color-stroke-info-hover": "var(--Tiime_Decorative_bleu-dark)",
      "color-stroke-info-active": "var(--Tiime_Decorative_bleu-dark)",
      "color-stroke-decorative": "rgb(0 0 0 / 0.15)",
      "color-stroke-decorative-hover": "rgb(0 0 0 / 0.25)",
      "color-stroke-decorative-active": "var(--Tiime_Decorative_Marine)",
      "color-stroke-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-base-tertiary": "var(--Tiime_Decorative_Marine)",
      "color-text-base-primary": "var(--Tiime_Secondaires_Gris-50)",
      "color-text-base-secondary": "var(--Tiime_Decorative_Marine)",
      "color-text-base-main": "var(--Tiime_Decorative_Marine)",
      "color-text-base-basic": "var(--Tiime_Secondaires_Marine)",
      "color-text-base-disable": "var(--Tiime_Secondaires_Gris-300)",
      "color-text-base-link": "var(--Tiime_Decorative_Marine)",
      "color-text-base-inverse": "var(--Tiime_Secondaires_Gris-50)",
      "color-text-danger-primary": "var(--Tiime_Decorative_rose-dark)",
      "color-text-danger-secondary": "var(--Tiime_Decorative_rose-dark)",
      "color-text-success-primary": "var(--Tiime_Decorative_vert-dark)",
      "color-text-success-secondary": "var(--Tiime_Decorative_vert-dark)",
      "color-text-warning-primary": "var(--Tiime_Decorative_jaune-dark)",
      "color-text-warning-secondary": "var(--Tiime_Decorative_jaune-dark)",
      "color-text-info-primary": "var(--Tiime_Decorative_bleu-dark)",
      "color-text-info-secondary": "var(--Tiime_Decorative_bleu-dark)",
      "color-text-decorative-secondary": "var(--Tiime_Decorative_Marine)",
      "color-text-decorative-tertiary": "var(--Tiime_Decorative_Marine)",
      "color-text-decorative-disable": "rgb(0 0 0 / 0.25)",
      "color-text-decorative-main": "var(--Tiime_Decorative_Marine)",
      "color-text-decorative-basic": "var(--Tiime_Secondaires_Marine)",
      "color-text-decorative-primary": "var(--White)",
      "color-text-decorative-1": "var(--Tiime_Decorative_violet)",
      "color-text-decorative-2": "var(--Tiime_Decorative_bleu)",
      "color-text-decorative-3": "var(--Tiime_Secondaires_Vert)",
      "color-text-decorative-4": "var(--Tiime_Decorative_jaune)",
      "color-text-decorative-5": "var(--Tiime_Decorative_orange)",
      "color-background-subtle": "var(--Tiime_Secondaires_Gris-50)"
    }
  }
}
